var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _path5, _line, _rect4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect5, _rect6, _rect7, _rect8, _rect9, _path13, _path14, _path15, _rect10, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect11, _path31, _path32, _path33, _path34, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle2, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _circle3, _rect34, _rect35, _rect36, _rect37, _path35, _path36, _mask, _path37, _circle4, _circle5, _circle6, _rect38, _path38, _mask2, _path39, _circle7, _circle8, _circle9, _path40, _circle10, _rect39, _path41, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _ellipse, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _rect48, _g, _rect49, _rect50, _path210, _rect51, _path211, _rect52, _path212, _path213, _path214, _ellipse2, _path215, _ellipse3, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _rect53, _path236, _rect54, _g2, _rect55, _circle11, _circle12, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _ellipse4, _ellipse5, _line2, _rect56, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _circle13, _circle14, _g3, _path264, _path265, _path266, _rect57, _ellipse6, _ellipse7, _ellipse8, _path267, _ellipse9, _ellipse10, _circle15, _circle16, _circle17, _circle18, _circle19, _path268, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _circle20, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _ellipse22, _ellipse23, _rect58, _g4, _path316, _ellipse24, _g5, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3713_16728)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 801,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 251H0V799H881V496H816V417L370 407L122 251Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 665H1198V800H0V665Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M622 418H664V666L622 674V418Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381 413.5H424V674L381 666.5V413.5Z",
    fill: "#222222"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 157,
    width: 131,
    height: 118,
    fill: "#8F8F8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131 157L381 318V433L131 275V157Z",
    fill: "#929292"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1043.5,
    y1: 801,
    x2: 1043.5,
    y2: 1,
    stroke: "#9A9A9A",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 301,
    width: 197,
    height: 127,
    fill: "#8F8F8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M381 318L424 301V428L381 433.5V318Z",
    fill: "#636363"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M664 318L621 301V428L664 435.5V318Z",
    fill: "#ACACAC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M664 318L825 402V519.5L664 435.5V318Z",
    fill: "#8D8D8D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M827.008 469H1044.15L1197.98 570.079V798H973.216L827.008 516.012V469Z",
    fill: "#222222",
    stroke: "black",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M774 466H1045",
    stroke: "#969696",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M825 402L995.5 579.5V715.75V783.875V800H968.5L963.531 789.656L952.875 768.875L910.25 685.75L825 519.5V402Z",
    fill: "#555555"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M825 519.5V666L901.5 739.5L939.75 776.25L963 800H970.5L967.75 795.5L957.5 778L939.75 739.625L901.5 666.25L825 519.5Z",
    fill: "#1D1D1D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 29,
    width: 113,
    height: 67,
    fill: "#8B8B8B",
    stroke: "#474747",
    strokeWidth: 6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 31,
    width: 144,
    height: 151,
    fill: "#B0B0B0",
    stroke: "#414141",
    strokeWidth: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 114,
    width: 113,
    height: 81,
    fill: "#ADADAD",
    stroke: "#393939",
    strokeWidth: 6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 723.455,
    y: 25.4554,
    width: 154.089,
    height: 161.089,
    fill: "#B3B3B3",
    stroke: "#444444",
    strokeWidth: 8.91089
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 23,
    width: 83,
    height: 99,
    fill: "#B4B4B4",
    stroke: "#3D3D3D",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M676.5 51.5C676.5 60.3696 668.692 68.8705 654.962 75.2417C641.358 81.555 622.457 85.5 601.5 85.5C580.543 85.5 561.642 81.555 548.038 75.2417C534.308 68.8705 526.5 60.3696 526.5 51.5C526.5 42.6304 534.308 34.1295 548.038 27.7583C561.642 21.445 580.543 17.5 601.5 17.5C622.457 17.5 641.358 21.445 654.962 27.7583C668.692 34.1295 676.5 42.6304 676.5 51.5Z",
    fill: "#464646",
    stroke: "#2B2B2B",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33 739H301.679V420.5L151.085 324H33V739Z",
    fill: "#6B6B6B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280 435.219V717.5H55V347.5H141.063L280 435.219Z",
    fill: "#0B0F21",
    stroke: "black",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 453.584,
    width: 224.268,
    height: 6.81779,
    fill: "#676767",
    stroke: "black",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55 540.5H279V547.875H55V540.5Z",
    fill: "#676767",
    stroke: "black",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55 622.5H279V629.5H55V622.5Z",
    fill: "#676767",
    stroke: "black",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.798 497.364C241.902 496.957 241.958 496.531 241.958 496.091C241.958 493.279 239.679 491 236.867 491C234.055 491 231.775 493.279 231.775 496.091C231.775 496.531 231.831 496.957 231.936 497.364H224.138C217.109 497.364 211.41 503.063 211.41 510.093V539.368H205.682C203.925 539.368 202.5 540.793 202.5 542.55C202.5 544.307 203.925 545.732 205.682 545.732H270.597C272.354 545.732 273.779 544.307 273.779 542.55C273.779 540.793 272.354 539.368 270.597 539.368H263.596V510.093C263.596 503.063 257.898 497.364 250.868 497.364H241.798Z",
    fill: "#676767"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M224.775 501.819C220.956 501.819 216.502 503.728 215.865 508.82M237.504 493.546C236.231 492.909 233.685 494.182 234.321 496.091",
    stroke: "#9C9C9C",
    strokeWidth: 2.54568,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.139 524.275C224.139 527.33 229.654 530.64 232.412 531.912L236.867 526.821C236.083 532.7 233.127 534.556 230.674 535.363C229.543 535.734 229.646 536.367 230.836 536.367H253.414C254.05 535.519 255.323 533.185 255.323 530.64C255.323 527.457 252.778 527.457 252.141 524.275C251.505 521.093 235.594 515.365 232.412 516.638C229.23 517.911 224.139 520.457 224.139 524.275Z",
    fill: "#CDCDCD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M232.412 531.912L231.879 533.068L232.743 533.467L233.37 532.751L232.412 531.912ZM253.414 536.367V537.64H254.05L254.432 537.131L253.414 536.367ZM230.674 535.363L230.276 534.153H230.276L230.674 535.363ZM236.867 526.821L238.129 526.989L238.686 522.809L235.909 525.983L236.867 526.821ZM232.946 530.757C231.632 530.15 229.657 529.054 228.033 527.765C227.22 527.12 226.538 526.46 226.068 525.823C225.59 525.175 225.412 524.659 225.412 524.275H222.866C222.866 525.419 223.376 526.462 224.019 527.334C224.67 528.217 225.539 529.036 226.45 529.759C228.273 531.206 230.435 532.402 231.879 533.068L232.946 530.757ZM225.412 524.275C225.412 522.97 226.287 521.708 227.854 520.515C229.387 519.346 231.329 518.442 232.885 517.82L231.939 515.456C230.313 516.107 228.119 517.112 226.311 518.49C224.536 519.842 222.866 521.762 222.866 524.275H225.412ZM232.885 517.82C233.016 517.768 233.382 517.703 234.077 517.741C234.732 517.778 235.55 517.897 236.487 518.093C238.359 518.485 240.603 519.16 242.784 519.978C244.969 520.797 247.043 521.742 248.59 522.656C249.365 523.115 249.97 523.544 250.383 523.921C250.835 524.334 250.896 524.54 250.893 524.525L253.389 524.026C253.227 523.215 252.652 522.546 252.1 522.042C251.508 521.501 250.74 520.971 249.885 520.465C248.17 519.45 245.948 518.446 243.678 517.594C241.405 516.742 239.035 516.025 237.008 515.601C235.997 515.39 235.044 515.245 234.218 515.2C233.431 515.156 232.604 515.191 231.939 515.456L232.885 517.82ZM250.893 524.525C251.288 526.5 252.325 527.531 253.025 528.309C253.375 528.699 253.611 528.988 253.777 529.319C253.931 529.628 254.05 530.028 254.05 530.64H256.596C256.596 529.66 256.397 528.867 256.054 528.181C255.723 527.518 255.282 527.012 254.917 526.606C254.185 525.793 253.631 525.233 253.389 524.026L250.893 524.525ZM254.05 530.64C254.05 532.821 252.93 534.892 252.396 535.604L254.432 537.131C255.171 536.146 256.596 533.55 256.596 530.64H254.05ZM253.414 535.094H230.836V537.64H253.414V535.094ZM231.071 536.572C232.433 536.124 234.011 535.359 235.352 533.835C236.695 532.309 237.711 530.124 238.129 526.989L235.605 526.653C235.24 529.397 234.385 531.08 233.441 532.153C232.494 533.229 231.368 533.795 230.276 534.153L231.071 536.572ZM233.37 532.751L237.825 527.659L235.909 525.983L231.454 531.074L233.37 532.751ZM230.836 535.094C230.632 535.094 230.583 535.065 230.631 535.084C230.641 535.088 231.053 535.258 231.141 535.8C231.229 536.344 230.89 536.637 230.881 536.645C230.841 536.679 230.877 536.636 231.071 536.572L230.276 534.153C229.905 534.275 229.53 534.451 229.228 534.708C228.957 534.939 228.507 535.46 228.628 536.208C228.749 536.955 229.34 537.307 229.668 537.441C230.035 537.591 230.445 537.64 230.836 537.64V535.094Z",
    fill: "#1E1E1E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.139 524.275C224.139 527.33 230.924 532.433 233.682 533.706C232.712 534.552 231.653 535.041 230.674 535.363C229.543 535.734 229.646 536.367 230.836 536.367H242.595H253.414C254.05 535.519 255.323 533.185 255.323 530.64C255.323 527.457 252.778 527.457 252.141 524.275C251.505 521.093 235.594 515.365 232.412 516.638C229.23 517.911 224.139 520.457 224.139 524.275Z",
    fill: "#CDCDCD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M233.682 533.706C230.924 532.433 224.139 527.33 224.139 524.275C224.139 520.457 229.23 517.911 232.412 516.638C235.594 515.365 251.505 521.093 252.141 524.275C252.778 527.457 255.323 527.457 255.323 530.64C255.323 533.185 254.05 535.519 253.414 536.367H242.595M236.867 526.821C236.083 532.7 233.127 534.556 230.674 535.363C229.543 535.734 229.646 536.367 230.836 536.367H242.595M247.05 529.185C243.656 528.245 238.013 528.366 242.595 536.367",
    stroke: "#1E1E1E",
    strokeWidth: 2.54568,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.685,
    cy: 522.185,
    r: 1.90926,
    fill: "#232323"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 681.5C221.5 683.433 215.232 685 207.5 685C199.768 685 193.5 683.433 193.5 681.5C193.5 679.567 199.768 678 207.5 678C215.232 678 221.5 679.567 221.5 681.5Z",
    fill: "#A3A3A3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 672C206.1 675.2 204.833 681.667 204 684.5C206.5 682 206.5 672.5 207 670C207.5 667.5 211 663.5 212 661C213 658.5 210 655 209 649.5C208.2 645.1 210.666 637.333 212 634C208.5 635.5 200.5 646.5 199.5 653.5C198.5 660.5 202.5 668 204.5 672Z",
    fill: "#D0D0D0",
    stroke: "#ABABAB",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 665.5C203.1 668.7 203.167 679.833 203.5 685C203.5 684 209.5 672.5 212 672C214.5 671.5 217.5 665.5 218 662C218.5 658.5 222 655.5 222.5 654C223 652.5 218.5 656 216.5 657.5C214.5 659 208.5 661.5 205.5 665.5Z",
    fill: "#D0D0D0",
    stroke: "#ABABAB",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 675.5C214.7 677.9 213.333 681.5 213 683C212 680 212 677 213 672.5C214 668 217.5 665 220 661.5C222.5 658 233 653.5 233 654C233 654.5 228.5 660.5 226.5 662.5C224.5 664.5 224.5 668.5 223 670.5C221.5 672.5 221 672.5 217.5 675.5Z",
    fill: "#D0D0D0",
    stroke: "#ABABAB",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 685.5C205.5 680.667 207.6 670.4 216 668C220 669.2 223.667 667.5 225 666.5C226.2 668.9 223.5 673.833 222 676C220.252 675.417 218.905 674.026 217.925 672.5C214.283 673.833 206.7 678.3 205.5 685.5Z",
    fill: "#D0D0D0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216 668C207.6 670.4 205.5 680.667 205.5 685.5C206.7 678.3 214.283 673.833 217.925 672.5M216 668C220 669.2 223.667 667.5 225 666.5C226.2 668.9 223.5 673.833 222 676C220.252 675.417 218.905 674.026 217.925 672.5M216 668C216.257 669.115 216.885 670.883 217.925 672.5",
    stroke: "#ABABAB",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 685C201.5 684.832 201.331 684.327 201.163 683.616C199.6 679.561 193.18 670.959 194.5 667C195.7 663.4 193.667 656.167 192.5 653C196 656 196 660.5 196.5 662C197 663.5 202.5 668.5 203 670.5C203.5 672.5 203 675 201.5 678C200.503 679.993 200.831 682.208 201.163 683.616C201.377 684.17 201.5 684.639 201.5 685Z",
    fill: "#D0D0D0",
    stroke: "#ABABAB",
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 705,
    width: 57,
    height: 10,
    fill: "#616161"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.525 695.5C186.125 690.7 190.691 683.5 193.025 680.5C195.025 680.5 202.119 683.014 207.525 682C215.525 680.5 218.858 680 221.025 679C222.691 681.5 224.825 685.7 226.025 688.5C227.525 692 230.025 697.5 228.025 700C226.025 702.5 225.025 701.5 222.525 701.5C220.525 701.5 220.691 706.833 221.025 709.5C219.858 710.667 215.525 713 207.525 713C199.525 713 194.525 709.667 193.025 708V701.5C193.025 700 187.025 701.5 186.525 695.5Z",
    fill: "#E9E9E9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.519 689C194.119 687 199.186 687.167 201.519 687.5C203.019 688 205.919 689.5 205.519 691.5C205.019 694 201.519 694 200.019 695C198.519 696 198.519 699.5 195.019 699C191.519 698.5 190.519 691.5 192.519 689Z",
    fill: "#171717"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.519 697.5C216.519 698 209.519 695 210.019 689C210.686 688 212.519 686 214.519 686C217.019 686 220.019 686 220.519 689C221.019 692 220.519 697 218.519 697.5Z",
    fill: "#171717"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M206.955 702.433C205.679 703.071 204.296 702.167 203.764 701.635C201.371 700.622 202.966 707.22 203.764 707.619C204.562 708.018 206.157 706.023 207.753 705.624C209.349 705.225 209.748 706.821 211.742 706.023C213.737 705.225 211.343 700.439 209.748 699.242C208.152 698.045 208.551 701.635 206.955 702.433Z",
    fill: "#171717"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 715,
    width: 6,
    height: 69,
    transform: "rotate(90 242.5 715)",
    fill: "#B1B1B1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 657,
    width: 11,
    height: 62,
    fill: "#6A6A6A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 669,
    width: 11,
    height: 50,
    fill: "#949494"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 650,
    width: 24,
    height: 69,
    fill: "#444444"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 667,
    width: 24,
    height: 3,
    fill: "#1A1A1A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 702,
    width: 24,
    height: 3,
    fill: "#1A1A1A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 689,
    width: 22,
    height: 2,
    fill: "#1A1A1A"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 681,
    width: 22,
    height: 2,
    fill: "#1A1A1A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 686,
    r: 2,
    fill: "#1A1A1A"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 674,
    width: 3,
    height: 32,
    fill: "#414141"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 683,
    width: 3,
    height: 26,
    fill: "#414141"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 103.509,
    y: 673.727,
    width: 10.9534,
    height: 46,
    transform: "rotate(-8.87505 103.509 673.727)",
    fill: "#A8A8A8"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 110.312,
    y: 710.672,
    width: 3,
    height: 9,
    transform: "rotate(-98.5688 110.312 710.672)",
    fill: "#676767"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 717,
    width: 42,
    height: 2,
    fill: "#878787"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 242.145,
    y: 566,
    width: 18,
    height: 58,
    fill: "#6C6C6C"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 260.145,
    y: 555,
    width: 17,
    height: 69,
    fill: "#BABABA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 262.145,
    y: 573,
    width: 13,
    height: 3,
    fill: "#6F6F6F"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 262.145,
    y: 605,
    width: 13,
    height: 3,
    fill: "#6F6F6F"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 266.145,
    y: 581,
    width: 5,
    height: 20,
    fill: "#6F6F6F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 581,
    width: 16,
    height: 2,
    fill: "#474747"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 598,
    width: 16,
    height: 2,
    fill: "#474747"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 602,
    width: 16,
    height: 2,
    fill: "#474747"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 230.214,
    y: 573.013,
    width: 12,
    height: 50,
    transform: "rotate(11.203 230.214 573.013)",
    fill: "#AFAFAF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.339,
    cy: 607.804,
    r: 3,
    transform: "rotate(11.203 229.339 607.804)",
    fill: "#7C7C7C"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 227.165,
    y: 598.198,
    width: 8,
    height: 2,
    transform: "rotate(11.203 227.165 598.198)",
    fill: "#7C7C7C"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 224.25,
    y: 612.912,
    width: 8,
    height: 2,
    transform: "rotate(11.203 224.25 612.912)",
    fill: "#7C7C7C"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 92.166,
    y: 601.667,
    width: 20,
    height: 21.3333,
    fill: "#6D6D6D"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 70.833,
    y: 575,
    width: 16,
    height: 48,
    fill: "#4D4D4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.487 583H104.314L103.358 589.123H101.444L100.487 583Z",
    fill: "#C8C8C8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.166 555H81.4993L80.8327 561.667H76.8327L76.166 555Z",
    fill: "#737373"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-76-inside-1_3713_16728",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1906 586.062C98.1906 585.639 98.5333 585.296 98.956 585.296H105.845C106.268 585.296 106.61 585.639 106.61 586.062V586.827C106.61 587.25 106.268 587.593 105.845 587.593V590.396C110.082 591.683 113.199 595.279 113.479 599.588C113.492 599.67 113.499 599.754 113.499 599.84V600.222V622.803C113.499 623.648 112.814 624.333 111.968 624.333H92.8326C91.9872 624.333 91.3018 623.648 91.3018 622.803V600.222V599.84C91.3018 599.754 91.3088 599.67 91.3223 599.588C91.6025 595.279 94.7189 591.683 98.9561 590.396V587.593H98.956C98.5333 587.593 98.1906 587.25 98.1906 586.827V586.062Z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M105.845 587.593L105.845 586.259L104.512 586.259V587.593H105.845ZM105.845 590.396H104.512V591.385L105.458 591.672L105.845 590.396ZM113.479 599.588L112.148 599.675L112.152 599.74L112.163 599.806L113.479 599.588ZM91.3223 599.588L92.6378 599.806L92.6486 599.74L92.6528 599.675L91.3223 599.588ZM98.9561 590.396L99.3435 591.672L100.289 591.385V590.396H98.9561ZM98.9561 587.593H100.289V586.259H98.9561V587.593ZM98.956 583.963C97.7969 583.963 96.8573 584.903 96.8573 586.062H99.5239C99.5239 586.375 99.2697 586.63 98.956 586.63V583.963ZM105.845 583.963H98.956V586.63H105.845V583.963ZM107.944 586.062C107.944 584.903 107.004 583.963 105.845 583.963V586.63C105.531 586.63 105.277 586.375 105.277 586.062H107.944ZM107.944 586.827V586.062H105.277V586.827H107.944ZM105.845 588.926C107.004 588.926 107.944 587.986 107.944 586.827H105.277C105.277 586.514 105.531 586.259 105.845 586.259L105.845 588.926ZM107.178 590.396V587.593H104.512V590.396H107.178ZM114.809 599.502C114.489 594.578 110.941 590.55 106.232 589.12L105.458 591.672C109.224 592.816 111.908 595.98 112.148 599.675L114.809 599.502ZM112.163 599.806C112.165 599.816 112.166 599.827 112.166 599.84H114.833C114.833 599.681 114.82 599.524 114.794 599.371L112.163 599.806ZM112.166 599.84V600.222H114.833V599.84H112.166ZM112.166 600.222V622.803H114.833V600.222H112.166ZM112.166 622.803C112.166 622.912 112.078 623 111.968 623V625.667C113.55 625.667 114.833 624.384 114.833 622.803H112.166ZM111.968 623H92.8326V625.667H111.968V623ZM92.8326 623C92.7235 623 92.6351 622.912 92.6351 622.803H89.9684C89.9684 624.384 91.2508 625.667 92.8326 625.667V623ZM92.6351 622.803V600.222H89.9684V622.803H92.6351ZM92.6351 600.222V599.84H89.9684V600.222H92.6351ZM92.6351 599.84C92.6351 599.827 92.6361 599.816 92.6378 599.806L90.0068 599.371C89.9815 599.524 89.9684 599.681 89.9684 599.84H92.6351ZM98.5686 589.12C93.8604 590.55 90.312 594.578 89.9918 599.502L92.6528 599.675C92.8931 595.98 95.5773 592.816 99.3435 591.672L98.5686 589.12ZM97.6227 587.593V590.396H100.289V587.593H97.6227ZM98.956 588.926H98.9561V586.259H98.956V588.926ZM96.8573 586.827C96.8573 587.986 97.7969 588.926 98.956 588.926V586.259C99.2697 586.259 99.5239 586.514 99.5239 586.827H96.8573ZM96.8573 586.062V586.827H99.5239V586.062H96.8573Z",
    fill: "#B1B1B1",
    mask: "url(#path-76-inside-1_3713_16728)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2771,
    cy: 604.049,
    r: 1.14815,
    fill: "#B8B8B8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.9568,
    cy: 602.136,
    r: 0.765432,
    fill: "#B8B8B8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.105,
    cy: 606.346,
    r: 1.91358,
    fill: "#B8B8B8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 95.1289,
    y: 609.79,
    width: 14.5432,
    height: 5.35803,
    fill: "#BFBFBF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6602 613.305C97.1858 612.462 97.8025 611.646 98.4169 610.865C98.477 610.789 98.7608 610.359 98.8023 610.663C98.8846 611.266 98.6915 611.941 98.6535 612.545C98.6357 612.826 98.6461 613.102 98.7013 613.379C98.7162 613.454 98.7842 613.894 98.9086 613.927C99.0128 613.954 99.4002 613.214 99.4375 613.156C99.4979 613.062 100.163 611.992 100.2 612.029C100.322 612.151 100.326 612.651 100.365 612.813C100.614 613.852 101.717 612.739 102.087 612.338C102.157 612.262 102.257 612.036 102.34 612.144C102.595 612.477 102.954 612.547 103.358 612.603C103.784 612.663 104.192 612.593 104.615 612.593C104.728 612.593 104.936 612.778 105.064 612.816C105.638 612.984 106.23 613.084 106.818 613.185C107.093 613.233 107.39 613.151 107.663 613.114",
    stroke: "#202020",
    strokeWidth: 0.765432,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-83-inside-2_3713_16728",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2931 557.667C75.2931 556.93 75.8901 556.333 76.6265 556.333H81.0403C81.7766 556.333 82.3736 556.93 82.3736 557.667V559C82.3736 559.484 82.1157 559.908 81.7299 560.141V565.217C85.322 567.476 87.9563 573.825 88.1546 581.412C88.1626 581.496 88.1667 581.581 88.1667 581.667V582.333V621.667C88.1667 623.139 86.9728 624.333 85.5 624.333H72.1667C70.6939 624.333 69.5 623.139 69.5 621.667V582.333V581.667C69.5 581.581 69.5041 581.496 69.512 581.412C69.7104 573.825 72.3446 567.476 75.9368 565.217V560.141C75.551 559.908 75.2931 559.484 75.2931 559V557.667Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7299 560.141L81.0393 559.001L80.3965 559.39V560.141H81.7299ZM81.7299 565.217H80.3965V565.953L81.02 566.346L81.7299 565.217ZM88.1546 581.412L86.8218 581.447L86.823 581.492L86.8273 581.538L88.1546 581.412ZM69.512 581.412L70.8394 581.538L70.8437 581.492L70.8449 581.447L69.512 581.412ZM75.9368 565.217L76.6467 566.346L77.2701 565.953V565.217H75.9368ZM75.9368 560.141H77.2701V559.39L76.6274 559.001L75.9368 560.141ZM76.6265 555C75.1537 555 73.9598 556.194 73.9598 557.667H76.6265V557.667V555ZM81.0403 555H76.6265V557.667H81.0403V555ZM83.7069 557.667C83.7069 556.194 82.513 555 81.0403 555V557.667H81.0403H83.7069ZM83.7069 559V557.667H81.0403V559H83.7069ZM82.4205 561.282C83.1887 560.817 83.7069 559.969 83.7069 559H81.0403C81.0403 559.002 81.04 559.002 81.0404 559.001C81.0406 559 81.041 558.999 81.0411 558.999C81.0411 558.999 81.0409 558.999 81.0403 559C81.0401 559 81.0398 559 81.0396 559.001C81.0394 559.001 81.0393 559.001 81.0393 559.001L82.4205 561.282ZM83.0632 565.217V560.141H80.3965V565.217H83.0632ZM89.4875 581.377C89.3848 577.446 88.6512 573.803 87.4521 570.819C86.2637 567.862 84.5646 565.425 82.4398 564.088L81.02 566.346C82.4873 567.268 83.9015 569.135 84.9778 571.814C86.0435 574.466 86.7262 577.79 86.8218 581.447L89.4875 581.377ZM86.8273 581.538C86.8313 581.58 86.8333 581.623 86.8333 581.667H89.5C89.5 581.539 89.4939 581.412 89.482 581.286L86.8273 581.538ZM86.8333 581.667V582.333H89.5V581.667H86.8333ZM86.8333 582.333V621.667H89.5V582.333H86.8333ZM86.8333 621.667C86.8333 622.403 86.2364 623 85.5 623V625.667C87.7091 625.667 89.5 623.876 89.5 621.667H86.8333ZM85.5 623H72.1667V625.667H85.5V623ZM72.1667 623C71.4303 623 70.8333 622.403 70.8333 621.667H68.1667C68.1667 623.876 69.9575 625.667 72.1667 625.667V623ZM70.8333 621.667V582.333H68.1667V621.667H70.8333ZM70.8333 582.333V581.667H68.1667V582.333H70.8333ZM70.8333 581.667C70.8333 581.623 70.8354 581.58 70.8394 581.538L68.1846 581.286C68.1727 581.412 68.1667 581.539 68.1667 581.667H70.8333ZM75.2269 564.088C73.102 565.425 71.403 567.862 70.2145 570.819C69.0155 573.803 68.2819 577.446 68.1791 581.377L70.8449 581.447C70.9405 577.79 71.6232 574.466 72.6889 571.814C73.7652 569.135 75.1793 567.269 76.6467 566.346L75.2269 564.088ZM74.6034 560.141V565.217H77.2701V560.141H74.6034ZM73.9598 559C73.9598 559.969 74.478 560.817 75.2461 561.282L76.6274 559.001C76.6274 559.001 76.6273 559.001 76.6271 559.001C76.6269 559 76.6267 559 76.6264 559C76.6258 558.999 76.6256 558.999 76.6257 558.999C76.6257 558.999 76.6261 559 76.6264 559.001C76.6267 559.002 76.6265 559.002 76.6265 559H73.9598ZM73.9598 557.667V559H76.6265V557.667H73.9598Z",
    fill: "#B1B1B1",
    mask: "url(#path-83-inside-2_3713_16728)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.4997,
    cy: 579.667,
    r: 0.666667,
    fill: "#C4C4C4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 582.333,
    r: 2,
    fill: "#C4C4C4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1663,
    cy: 577.667,
    r: 1.33333,
    fill: "#C4C4C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5003 591.667C81.5003 592.035 81.2018 592.333 80.8337 592.333C80.4655 592.333 80.167 592.035 80.167 591.667C80.167 591.298 80.4655 591 80.8337 591C81.2018 591 81.5003 591.298 81.5003 591.667Z",
    fill: "#C4C4C4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5003,
    cy: 593.667,
    r: 1.33333,
    fill: "#C4C4C4"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 72.167,
    y: 599,
    width: 13.3333,
    height: 5.33333,
    fill: "#AFAFAF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.375 602.25C74.4281 601.435 75.048 600.551 75.8472 600.285C75.9387 600.254 76.3241 600.138 76.3912 600.257C76.5067 600.462 76.3112 600.913 76.2454 601.104C76.1327 601.432 75.994 601.75 75.8796 602.076C75.7726 602.382 76.2064 602.022 76.2986 601.972C76.6884 601.762 77.2458 601.464 77.6968 601.637C77.9934 601.75 78.0143 601.983 78.0417 602.264C78.0894 602.753 78.561 602.582 78.9028 602.435C79.1131 602.345 79.6228 601.838 79.8611 601.968C80.3664 602.243 80.9488 602.157 81.4954 602.083C81.8252 602.039 82.0963 602.072 82.4167 602.125",
    stroke: "#1F1F1F",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 386,
    width: 17,
    height: 69,
    fill: "#B5B5B5"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 398,
    width: 13,
    height: 57,
    fill: "#747474"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 402,
    width: 9,
    height: 35,
    fill: "#949494"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 414,
    width: 3,
    height: 35,
    fill: "#4D4D4D"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 542,
    width: 17,
    height: 101,
    transform: "rotate(-90 61 542)",
    fill: "#585858"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 70.2822,
    y: 525,
    width: 13,
    height: 83.4348,
    transform: "rotate(-90 70.2822 525)",
    fill: "#666666"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 536,
    width: 4,
    height: 46,
    transform: "rotate(-90 68.5 536)",
    fill: "#7C7C7C"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 521,
    width: 4,
    height: 43,
    transform: "rotate(-90 83.5 521)",
    fill: "#484848"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M179.685 423.582C180.2 414.826 176.826 398.087 159.212 401.177C137.193 405.04 123.287 432.467 123.287 460.666C123.287 484.258 123.287 491.569 141.442 519.382C148.54 530.255 172.732 555.693 171.187 576.939C169.641 598.185 152.645 603.207 154.19 621.362C155.735 639.518 173.504 644.54 163.847 657.673C154.19 670.807 143.126 654.583 151.872 646.085",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M188.569 407.744C191.273 407.229 196.527 404.113 195.909 395.769C192.947 396.799 187.333 400.637 188.569 407.744Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M174.232 394.393C175.546 391.974 176.462 385.935 169.614 381.129C168.535 384.073 167.949 390.848 174.232 394.393Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M151 460.064C150.873 462.813 152.684 468.647 160.943 469.983C160.629 466.864 158.201 460.512 151 460.064Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.613 453.266C145.866 453.08 139.995 454.764 138.48 462.992C141.606 462.746 148.009 460.455 148.613 453.266Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M143.065 480.096C141.373 482.267 139.483 488.076 145.454 493.936C146.999 491.208 148.684 484.62 143.065 480.096Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.849 507.779C118.625 506.157 112.76 504.453 107.092 510.607C109.868 512.065 116.506 513.54 120.849 507.779Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.592 490.656C130.743 488.617 125.347 485.756 118.547 490.63C120.969 492.622 127.169 495.414 132.592 490.656Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M114.634 519.748C112.003 518.939 105.902 519.235 102.545 526.899C105.645 527.374 112.402 526.609 114.634 519.748Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M115.565 534.069C112.89 534.718 107.797 538.091 108.828 546.394C111.735 545.218 117.152 541.107 115.565 534.069Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M122.175 546.47C119.713 547.702 115.507 552.131 118.374 559.991C120.943 558.193 125.3 552.972 122.175 546.47Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M136.11 584.005C137.212 581.483 137.607 575.388 130.372 571.186C129.55 574.212 129.546 581.012 136.11 584.005Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M121.689 541.489C123.276 543.738 128.285 547.233 135.627 543.221C133.464 540.95 127.65 537.425 121.689 541.489Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M116.481 524.978C116.107 527.705 117.386 533.678 125.492 535.752C125.459 532.617 123.612 526.072 116.481 524.978Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M131.1 552.47C132.062 555.049 136.017 559.704 144.138 557.693C142.625 554.946 137.899 550.057 131.1 552.47Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M142.688 566.376C143.65 568.955 147.605 573.61 155.726 571.599C154.213 568.853 149.487 563.963 142.688 566.376Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M141.658 583.597C139.612 585.437 136.731 590.823 141.58 597.642C143.58 595.227 146.396 589.037 141.658 583.597Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M132.397 586.523C129.719 585.889 123.651 586.589 120.808 594.458C123.932 594.726 130.624 593.516 132.397 586.523Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M124 578.86C122.59 576.496 117.864 572.626 110.236 576.063C112.217 578.493 117.744 582.455 124 578.86Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M123.283 569.261C122.707 566.57 119.473 561.387 111.146 562.193C112.242 565.131 116.205 570.657 123.283 569.261Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M121.059 511.811C120.279 514.451 120.643 520.548 128.343 523.82C128.784 520.716 127.944 513.968 121.059 511.811Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M129.158 497.865C127.467 500.037 125.576 505.845 131.547 511.706C133.093 508.977 134.778 502.389 129.158 497.865Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M144.79 473.426C142.46 471.961 136.492 470.663 131.259 477.191C134.129 478.455 140.853 479.471 144.79 473.426Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M149.522 443.785C150.197 446.454 153.621 451.512 161.913 450.398C160.708 447.503 156.543 442.128 149.522 443.785Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M137.529 449.463C140.233 448.948 145.487 445.832 144.869 437.489C141.907 438.519 136.293 442.356 137.529 449.463Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M143.659 426.115C144.528 428.727 148.313 433.521 156.501 431.803C155.088 429.004 150.541 423.948 143.659 426.115Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M132.121 432.467C134.825 431.952 140.079 428.836 139.461 420.492C136.499 421.522 130.885 425.359 132.121 432.467Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M140.67 411.396C141.095 414.116 144.035 419.47 152.395 419.129C151.464 416.135 147.815 410.396 140.67 411.396Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M182.672 404.828C180.661 402.948 175.047 400.542 168.672 405.96C171.25 407.745 177.659 410.017 182.672 404.828Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M150.233 395.859C148.173 397.684 145.252 403.049 150.05 409.903C152.068 407.503 154.93 401.335 150.233 395.859Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M141.705 400.243C139.435 398.686 133.523 397.151 128.034 403.465C130.851 404.842 137.529 406.126 141.705 400.243Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M157.045 390.891C158.109 388.232 158.384 381.94 150.977 378.044C150.207 381.204 150.342 388.198 157.045 390.891Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M190.501 423.554C190.243 416.472 185.556 399.991 171.959 395.355C154.962 389.561 148.782 394.196 144.146 399.604C139.511 405.012 137.579 417.76 144.146 430.894C150.713 444.028 151.486 459.479 149.941 465.66C148.395 471.84 136.034 486.519 131.012 494.245C125.991 501.971 112.471 515.491 116.333 531.329C120.196 547.167 136.42 556.824 141.442 568.026C147.237 580.954 139.125 585.409 133.716 585.409C128.092 585.409 124.446 579.229 124.059 574.207C123.673 569.185 123.287 569.572 123.287 569.572",
    stroke: "#BCBCBC",
    strokeWidth: 2.31773,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M177.182 413.065C176.022 410.568 171.719 406.234 163.778 408.869C165.499 411.49 170.59 415.998 177.182 413.065Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M162.791 399.579C162.523 396.839 159.896 391.325 151.531 391.184C152.288 394.226 155.6 400.165 162.791 399.579Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M147.207 403.829C146.252 401.248 142.308 396.583 134.182 398.575C135.689 401.325 140.403 406.226 147.207 403.829Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M135.59 415.092C134.198 412.717 129.5 408.813 121.847 412.193C123.81 414.638 129.308 418.64 135.59 415.092Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M128.583 425.424C126.467 423.664 120.722 421.589 114.673 427.369C117.351 429.001 123.882 430.896 128.583 425.424Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M123.927 439.204C121.538 437.836 115.52 436.787 110.563 443.527C113.483 444.671 120.243 445.407 123.927 439.204Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M121.572 455.524C118.824 455.36 112.967 457.094 111.521 465.335C114.645 465.062 121.028 462.718 121.572 455.524Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M123.112 474.745C120.397 475.197 115.072 478.189 115.494 486.545C118.479 485.585 124.181 481.88 123.112 474.745Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M125.429 494.059C122.714 494.511 117.389 497.504 117.812 505.86C120.797 504.899 126.499 501.194 125.429 494.059Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M131.61 507.193C128.895 507.645 123.57 510.637 123.992 518.993C126.977 518.033 132.68 514.328 131.61 507.193Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M139.975 519.429C137.51 520.654 133.292 525.072 136.138 532.94C138.712 531.149 143.083 525.94 139.975 519.429Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M148.473 532.563C146.008 533.788 141.79 538.206 144.636 546.074C147.21 544.283 151.581 539.074 148.473 532.563Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M158.65 546.023C155.924 546.401 150.519 549.247 150.714 557.612C153.724 556.733 159.525 553.185 158.65 546.023Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M165.603 558.385C162.877 558.762 157.472 561.609 157.667 569.973C160.677 569.094 166.478 565.546 165.603 558.385Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M169.489 579.447C166.886 578.552 160.778 578.65 157.174 586.201C160.257 586.777 167.035 586.231 169.489 579.447Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M160.251 598.954C158.03 597.328 152.169 595.61 146.487 601.752C149.26 603.216 155.895 604.705 160.251 598.954Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 610.543C151.85 608.916 145.988 607.199 140.307 613.341C143.08 614.805 149.715 616.294 154.07 610.543Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M154.219 628.79C152.326 626.791 146.867 624.05 140.176 629.073C142.642 631.011 148.902 633.666 154.219 628.79Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M150.446 646.658C150.759 643.924 149.347 637.981 141.197 636.089C141.299 639.223 143.293 645.724 150.446 646.658Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M149.45 659.75C147.427 657.883 141.797 655.514 135.459 660.976C138.049 662.743 144.473 664.972 149.45 659.75Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M157.001 663.923C154.723 665.47 151.139 670.415 155.019 677.828C157.328 675.707 160.957 669.956 157.001 663.923Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M166.783 655.509C165.935 658.128 166.141 664.232 173.755 667.702C174.275 664.61 173.61 657.842 166.783 655.509Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M167.439 645.167C168.056 647.85 171.368 652.982 179.683 652.049C178.541 649.128 174.495 643.663 167.439 645.167Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M158.257 631.486C159.573 633.904 164.144 637.956 171.901 634.821C170.016 632.315 164.648 628.14 158.257 631.486Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M155.353 615.356C155.746 618.081 158.623 623.469 166.987 623.226C166.09 620.221 162.509 614.44 155.353 615.356Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M165.426 596.79C164.493 599.38 164.5 605.488 171.996 609.204C172.617 606.131 172.173 599.345 165.426 596.79Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M171.204 585.219C170.964 587.962 172.532 593.865 180.729 595.541C180.544 592.411 178.38 585.965 171.204 585.219Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M172.032 569.528C172.665 572.207 176.01 577.318 184.318 576.334C183.159 573.421 179.079 567.981 172.032 569.528Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M165.194 551.22C166.554 553.614 171.197 557.582 178.896 554.308C176.966 551.837 171.524 547.759 165.194 551.22Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M155.924 535.769C157.283 538.162 161.926 542.131 169.625 538.857C167.696 536.385 162.254 532.307 155.924 535.769Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M145.566 521.951C147.266 524.116 152.449 527.349 159.575 522.965C157.298 520.808 151.31 517.586 145.566 521.951Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M133.519 502.548C134.878 504.941 139.521 508.91 147.22 505.636C145.29 503.164 139.849 499.086 133.519 502.548Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M125.793 483.233C127.152 485.627 131.795 489.596 139.495 486.321C137.565 483.85 132.123 479.772 125.793 483.233Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M125.235 460.84C125.561 463.574 128.307 469.03 136.673 468.99C135.851 465.965 132.411 460.099 125.235 460.84Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M126.007 446.161C126.334 448.895 129.079 454.351 137.446 454.311C136.623 451.286 133.183 445.42 126.007 446.161Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M130.102 431.111C129.83 433.85 131.329 439.772 139.505 441.544C139.357 438.412 137.269 431.941 130.102 431.111Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M141.268 413.681C140.11 416.178 139.579 422.263 146.719 426.625C147.608 423.619 147.764 416.82 141.268 413.681Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.771 403.557C154.42 404.989 150.597 409.752 154.107 417.347C156.518 415.342 160.426 409.777 156.771 403.557Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M162.63 643.012C161.246 640.632 156.563 636.711 148.897 640.064C150.852 642.515 156.336 646.537 162.63 643.012Z",
    fill: "#BCBCBC",
    stroke: "#BDBDBD",
    strokeWidth: 2.31773
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M191.16 454.871C199.195 444.055 200.173 429.505 199.658 423.582H164.892C164.377 429.505 165.356 444.055 173.391 454.871H191.16Z",
    fill: "#777777"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 594,
    cy: 730.5,
    rx: 164,
    ry: 40.5,
    fill: "#484848"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.218 351.436C504.308 349.215 497.904 346.38 497.904 346.38C497.904 346.38 491.499 349.215 488.589 351.436C485.679 353.658 483 357.757 483 357.757L485.173 370.009L483 382.042L485.173 394.513L483 418.143H512.807L510.712 394.513L512.807 382.042L510.168 370.009L512.807 357.757C512.807 357.757 510.129 353.658 507.218 351.436Z",
    fill: "#505050"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M500.698 339.378C500.698 339.378 503.716 333.361 506.08 330.627C508.445 327.893 512.807 325.376 512.807 325.376L512.807 353.381C512.807 353.381 508.445 350.864 506.08 348.13C503.716 345.396 500.698 339.378 500.698 339.378Z",
    fill: "#505050"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M495.109 339.378C495.109 339.378 492.092 345.396 489.727 348.13C487.363 350.864 483 353.381 483 353.381L483 325.376C483 325.376 487.363 327.893 489.727 330.627C492.092 333.361 495.109 339.378 495.109 339.378Z",
    fill: "#505050"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M497.904 332.377C497.904 332.377 491.499 329.542 488.589 327.321C485.679 325.099 483 321 483 321L512.808 321C512.808 321 510.129 325.099 507.219 327.321C504.309 329.542 497.904 332.377 497.904 332.377Z",
    fill: "#505050"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.218 351.436C553.308 349.215 546.904 346.38 546.904 346.38C546.904 346.38 540.499 349.215 537.589 351.436C534.679 353.658 532 357.757 532 357.757L534.173 370.009L532 382.042L534.173 394.513L532 418.143H561.807L559.712 394.513L561.807 382.042L559.168 370.009L561.807 357.757C561.807 357.757 559.129 353.658 556.218 351.436Z",
    fill: "#505050"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M549.698 339.378C549.698 339.378 552.716 333.361 555.08 330.627C557.445 327.893 561.807 325.376 561.807 325.376L561.807 353.381C561.807 353.381 557.445 350.864 555.08 348.13C552.716 345.396 549.698 339.378 549.698 339.378Z",
    fill: "#505050"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M544.109 339.378C544.109 339.378 541.092 345.396 538.727 348.13C536.363 350.864 532 353.381 532 353.381L532 325.376C532 325.376 536.363 327.893 538.727 330.627C541.092 333.361 544.109 339.378 544.109 339.378Z",
    fill: "#505050"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M546.904 332.377C546.904 332.377 540.499 329.542 537.589 327.321C534.679 325.099 532 321 532 321L561.808 321C561.808 321 559.129 325.099 556.219 327.321C553.309 329.542 546.904 332.377 546.904 332.377Z",
    fill: "#505050"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M653 359.031C651 356.492 645.5 351.993 645.5 351.993C645.5 351.993 638.699 354.985 636.062 356.995C633.426 359.005 631 362.713 631 362.713L633.5 371.23L631 382.96L632.969 395.967L631 419.403L658 424.403L655.609 399.382L658 387.182L655.609 373.798L658 366.538C658 366.538 655.609 362.343 653 359.031Z",
    fill: "#3E3E3E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M648.5 345.893C648.5 345.893 649.764 342.226 651.906 339.752C654.048 337.278 658 335.177 658 335.177V360.908C658 360.908 655.142 357.751 653 355.277C650.858 352.804 648.5 345.893 648.5 345.893Z",
    fill: "#3E3E3E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M641.969 345.135C641.969 345.135 639.142 349.947 637 352.42C634.858 354.894 631 357.803 631 357.803L631 329.459C631 329.459 636.358 335.9 638.5 338.374C640.642 340.847 641.969 345.135 641.969 345.135Z",
    fill: "#3E3E3E"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 339.752C646.5 339.752 641.136 336.643 638.5 334.633C635.864 332.623 631.5 322.903 631.5 322.903L658 329.459C658 329.459 654.542 334.03 651.906 336.04C649.27 338.05 646.5 339.752 646.5 339.752Z",
    fill: "#3E3E3E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M645.5 323.403C645.5 323.403 639.136 320.953 636.5 318.903C633.864 316.852 631.379 309 631.379 309L656.5 318.5C656.5 318.5 655.136 319.352 652.5 321.403C649.864 323.453 645.5 323.403 645.5 323.403Z",
    fill: "#242546"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M394 359.128C396 356.589 401.5 352.09 401.5 352.09C401.5 352.09 408.301 355.082 410.938 357.092C413.574 359.102 416 362.81 416 362.81L413.5 371.327L416 383.057L414.031 396.064L416 419.5L389 424.5L391.391 399.479L389 387.28L391.391 373.895L389 366.635C389 366.635 391.391 362.44 394 359.128Z",
    fill: "#393939"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M398.5 345.991C398.5 345.991 397.236 342.323 395.094 339.849C392.952 337.375 389 335.274 389 335.274V361.005C389 361.005 391.858 357.848 394 355.374C396.142 352.901 398.5 345.991 398.5 345.991Z",
    fill: "#393939"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M405.031 345.232C405.031 345.232 407.858 350.044 410 352.517C412.142 354.991 416 357.901 416 357.901L416 329.556C416 329.556 410.642 335.997 408.5 338.471C406.358 340.944 405.031 345.232 405.031 345.232Z",
    fill: "#393939"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M400.5 339.849C400.5 339.849 405.864 336.74 408.5 334.73C411.136 332.72 415.5 323 415.5 323L389 330.5C389 330.5 392.458 334.128 395.094 336.137C397.73 338.147 400.5 339.849 400.5 339.849Z",
    fill: "#393939"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M401.5 324.403C401.5 324.403 406.364 321.05 409 319C411.636 316.95 415.621 310 415.621 310L389.5 319.903C389.5 319.903 391.5 321.597 394.5 323C397.5 324.403 401.5 324.403 401.5 324.403Z",
    fill: "#393939"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.218 351.436C455.308 349.215 448.904 346.38 448.904 346.38C448.904 346.38 442.499 349.215 439.589 351.436C436.679 353.658 434 357.757 434 357.757L436.173 370.009L434 382.042L436.173 394.513L434 418.143H463.807L461.712 394.513L463.807 382.042L461.168 370.009L463.807 357.757C463.807 357.757 461.129 353.658 458.218 351.436Z",
    fill: "#505050"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M451.698 339.378C451.698 339.378 454.716 333.361 457.08 330.627C459.445 327.893 463.807 325.376 463.807 325.376L463.807 353.381C463.807 353.381 459.445 350.864 457.08 348.13C454.716 345.396 451.698 339.378 451.698 339.378Z",
    fill: "#505050"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M446.109 339.378C446.109 339.378 443.092 345.396 440.727 348.13C438.363 350.864 434 353.381 434 353.381L434 325.376C434 325.376 438.363 327.893 440.727 330.627C443.092 333.361 446.109 339.378 446.109 339.378Z",
    fill: "#505050"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M448.904 332.377C448.904 332.377 442.499 329.542 439.589 327.321C436.679 325.099 434 321 434 321L463.808 321C463.808 321 461.129 325.099 458.219 327.321C455.309 329.542 448.904 332.377 448.904 332.377Z",
    fill: "#505050"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M448.714 317.143C448.714 317.143 442.821 314.366 440.143 312.19C437.465 310.015 435 306 435 306L462.429 306C462.429 306 459.964 310.015 457.286 312.19C454.608 314.366 448.714 317.143 448.714 317.143Z",
    fill: "#505050"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M497.714 317.143C497.714 317.143 491.821 314.366 489.143 312.19C486.465 310.015 484 306 484 306L511.429 306C511.429 306 508.964 310.015 506.286 312.19C503.608 314.366 497.714 317.143 497.714 317.143Z",
    fill: "#505050"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M546.714 317.143C546.714 317.143 540.821 314.366 538.143 312.19C535.465 310.015 533 306 533 306L560.429 306C560.429 306 557.964 310.015 555.286 312.19C552.608 314.366 546.714 317.143 546.714 317.143Z",
    fill: "#505050"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.218 351.436C602.308 349.215 595.904 346.38 595.904 346.38C595.904 346.38 589.499 349.215 586.589 351.436C583.679 353.658 581 357.757 581 357.757L583.173 370.009L581 382.042L583.173 394.513L581 418.143H610.807L608.712 394.513L610.807 382.042L608.168 370.009L610.807 357.757C610.807 357.757 608.129 353.658 605.218 351.436Z",
    fill: "#505050"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M598.698 339.378C598.698 339.378 601.716 333.361 604.08 330.627C606.445 327.893 610.807 325.376 610.807 325.376L610.807 353.381C610.807 353.381 606.445 350.864 604.08 348.13C601.716 345.396 598.698 339.378 598.698 339.378Z",
    fill: "#505050"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M593.109 339.378C593.109 339.378 590.092 345.396 587.727 348.13C585.363 350.864 581 353.381 581 353.381L581 325.376C581 325.376 585.363 327.893 587.727 330.627C590.092 333.361 593.109 339.378 593.109 339.378Z",
    fill: "#505050"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M595.904 332.377C595.904 332.377 589.499 329.542 586.589 327.321C583.679 325.099 581 321 581 321L610.808 321C610.808 321 608.129 325.099 605.219 327.321C602.309 329.542 595.904 332.377 595.904 332.377Z",
    fill: "#505050"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M595.714 317.143C595.714 317.143 589.821 314.366 587.143 312.19C584.465 310.015 582 306 582 306L609.429 306C609.429 306 606.964 310.015 604.286 312.19C601.608 314.366 595.714 317.143 595.714 317.143Z",
    fill: "#505050"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.275 205.79C112.598 203.746 106.708 201.139 106.708 201.139C106.708 201.139 100.817 203.746 98.1403 205.79C95.4638 207.833 93 211.603 93 211.603L94.999 222.872L93 233.94L94.999 245.41L93 267.143H120.415L118.488 245.41L120.415 233.94L117.988 222.872L120.415 211.603C120.415 211.603 117.951 207.833 115.275 205.79Z",
    fill: "#3E3E3E"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M109.277 194.7C109.277 194.7 112.053 189.165 114.227 186.65C116.402 184.136 120.415 181.821 120.415 181.821L120.415 207.578C120.415 207.578 116.402 205.264 114.227 202.749C112.053 200.234 109.277 194.7 109.277 194.7Z",
    fill: "#3E3E3E"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M104.138 194.7C104.138 194.7 101.362 200.234 99.1877 202.749C97.013 205.264 93.0003 207.578 93.0003 207.578L93.0003 181.821C93.0003 181.821 97.013 184.136 99.1877 186.65C101.362 189.165 104.138 194.7 104.138 194.7Z",
    fill: "#3E3E3E"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M106.707 188.26C106.707 188.26 100.817 185.653 98.1402 183.61C95.4637 181.566 92.9999 177.796 92.9999 177.796L120.415 177.796C120.415 177.796 117.951 181.566 115.275 183.61C112.598 185.653 106.707 188.26 106.707 188.26Z",
    fill: "#3E3E3E"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2748 205.79C70.5982 203.746 64.7076 201.139 64.7076 201.139C64.7076 201.139 58.8169 203.746 56.1403 205.79C53.4638 207.833 51 211.603 51 211.603L52.999 222.872L51 233.94L52.999 245.41L51 267.143H78.4152L76.4875 245.41L78.4152 233.94L75.9878 222.872L78.4152 211.603C78.4152 211.603 75.9514 207.833 73.2748 205.79Z",
    fill: "#3E3E3E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2773 194.7C67.2773 194.7 70.0526 189.165 72.2273 186.65C74.402 184.136 78.4147 181.821 78.4147 181.821L78.4147 207.578C78.4147 207.578 74.402 205.264 72.2273 202.749C70.0526 200.234 67.2773 194.7 67.2773 194.7Z",
    fill: "#3E3E3E"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1377 194.7C62.1377 194.7 59.3625 200.234 57.1877 202.749C55.013 205.264 51.0003 207.578 51.0003 207.578L51.0003 181.821C51.0003 181.821 55.013 184.136 57.1877 186.65C59.3625 189.165 62.1377 194.7 62.1377 194.7Z",
    fill: "#3E3E3E"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7075 188.26C64.7075 188.26 58.8168 185.653 56.1402 183.61C53.4637 181.566 50.9999 177.796 50.9999 177.796L78.415 177.796C78.415 177.796 75.9513 181.566 73.2747 183.61C70.5981 185.653 64.7075 188.26 64.7075 188.26Z",
    fill: "#3E3E3E"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2748 205.79C28.5982 203.746 22.7076 201.139 22.7076 201.139C22.7076 201.139 16.8169 203.746 14.1403 205.79C11.4638 207.833 9 211.603 9 211.603L10.999 222.872L9 233.94L10.999 245.41L9 267.143H36.4152L34.4875 245.41L36.4152 233.94L33.9878 222.872L36.4152 211.603C36.4152 211.603 33.9514 207.833 31.2748 205.79Z",
    fill: "#3E3E3E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2773 194.7C25.2773 194.7 28.0526 189.165 30.2273 186.65C32.402 184.136 36.4147 181.821 36.4147 181.821L36.4147 207.578C36.4147 207.578 32.402 205.264 30.2273 202.749C28.0526 200.234 25.2773 194.7 25.2773 194.7Z",
    fill: "#3E3E3E"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1377 194.7C20.1377 194.7 17.3625 200.234 15.1877 202.749C13.013 205.264 9.00029 207.578 9.00029 207.578L9.00029 181.821C9.00029 181.821 13.013 184.136 15.1877 186.65C17.3625 189.165 20.1377 194.7 20.1377 194.7Z",
    fill: "#3E3E3E"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7075 188.26C22.7075 188.26 16.8168 185.653 14.1402 183.61C11.4637 181.566 8.99989 177.796 8.99989 177.796L36.415 177.796C36.415 177.796 33.9513 181.566 31.2747 183.61C28.5981 185.653 22.7075 188.26 22.7075 188.26Z",
    fill: "#3E3E3E"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 174C106.5 174 101.128 171.508 98.6875 169.556C96.2467 167.603 94 164 94 164L119 164C119 164 116.753 167.603 114.313 169.556C111.872 171.508 106.5 174 106.5 174Z",
    fill: "#3E3E3E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 174C64.5 174 59.1283 171.508 56.6875 169.556C54.2467 167.603 52 164 52 164L77 164C77 164 74.7533 167.603 72.3125 169.556C69.8717 171.508 64.5 174 64.5 174Z",
    fill: "#3E3E3E"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 174C22.5 174 17.1283 171.508 14.6875 169.556C12.2467 167.603 10 164 10 164L35 164C35 164 32.7533 167.603 30.3125 169.556C27.8717 171.508 22.5 174 22.5 174Z",
    fill: "#3E3E3E"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.579 383.197C695.986 379.91 690.279 374.494 690.279 374.494C690.279 374.494 684.573 374.095 681.98 374.74C679.387 375.384 677 377.795 677 377.795L678.937 389.622L677 399.283L678.937 411.304L677 431.225L703.559 444.757L701.691 422.898L703.559 412.815L701.207 400.97L703.559 391.327C703.559 391.327 701.172 386.484 698.579 383.197Z",
    fill: "#3E3E3E"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M692.77 369.568C692.77 369.568 695.458 365.614 697.565 364.268C699.672 362.922 703.559 362.676 703.559 362.676L703.559 387.455C703.559 387.455 699.672 383.248 697.565 379.755C695.458 376.263 692.77 369.568 692.77 369.568Z",
    fill: "#3E3E3E"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M687.789 367.031C687.789 367.031 685.101 370.985 682.994 372.331C680.887 373.677 677 373.923 677 373.923L677 349.144C677 349.144 680.887 353.351 682.994 356.844C685.101 360.337 687.789 367.031 687.789 367.031Z",
    fill: "#3E3E3E"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M690.279 362.105C690.279 362.105 684.573 356.689 681.98 353.402C679.387 350.115 677 345.272 677 345.272L703.559 358.805C703.559 358.805 701.172 361.215 698.579 361.86C695.986 362.504 690.279 362.105 690.279 362.105Z",
    fill: "#3E3E3E"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M690.111 348.539C690.111 348.539 684.859 343.407 682.473 340.266C680.087 337.125 677.891 332.454 677.891 332.454L702.33 344.906C702.33 344.906 700.134 347.339 697.748 348.049C695.362 348.758 690.111 348.539 690.111 348.539Z",
    fill: "#3E3E3E"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M735.579 404.197C732.986 400.91 727.279 395.494 727.279 395.494C727.279 395.494 721.573 395.095 718.98 395.74C716.387 396.384 714 398.795 714 398.795L715.937 410.622L714 420.283L715.937 432.304L714 452.225L740.559 465.757L738.691 443.898L740.559 433.815L738.207 421.97L740.559 412.327C740.559 412.327 738.172 407.484 735.579 404.197Z",
    fill: "#3E3E3E"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M729.77 390.568C729.77 390.568 732.458 386.614 734.565 385.268C736.672 383.922 740.559 383.676 740.559 383.676L740.559 408.455C740.559 408.455 736.672 404.248 734.565 400.755C732.458 397.263 729.77 390.568 729.77 390.568Z",
    fill: "#3E3E3E"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M724.789 388.031C724.789 388.031 722.101 391.985 719.994 393.331C717.887 394.677 714 394.923 714 394.923L714 370.144C714 370.144 717.887 374.351 719.994 377.844C722.101 381.337 724.789 388.031 724.789 388.031Z",
    fill: "#3E3E3E"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M727.279 383.105C727.279 383.105 721.573 377.689 718.98 374.402C716.387 371.115 714 366.272 714 366.272L740.559 379.805C740.559 379.805 738.172 382.215 735.579 382.86C732.986 383.504 727.279 383.105 727.279 383.105Z",
    fill: "#3E3E3E"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M727.111 369.539C727.111 369.539 721.859 364.407 719.473 361.266C717.087 358.125 714.891 353.454 714.891 353.454L739.33 365.906C739.33 365.906 737.134 368.339 734.748 369.049C732.362 369.758 727.111 369.539 727.111 369.539Z",
    fill: "#3E3E3E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.579 425.197C772.986 421.91 767.279 416.494 767.279 416.494C767.279 416.494 761.573 416.095 758.98 416.74C756.387 417.384 754 419.795 754 419.795L755.937 431.622L754 441.283L755.937 453.304L754 473.225L780.559 486.757L778.691 464.898L780.559 454.815L778.207 442.97L780.559 433.327C780.559 433.327 778.172 428.484 775.579 425.197Z",
    fill: "#3E3E3E"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M769.77 411.568C769.77 411.568 772.458 407.614 774.565 406.268C776.672 404.922 780.559 404.676 780.559 404.676L780.559 429.455C780.559 429.455 776.672 425.248 774.565 421.755C772.458 418.263 769.77 411.568 769.77 411.568Z",
    fill: "#3E3E3E"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M764.789 409.031C764.789 409.031 762.101 412.985 759.994 414.331C757.887 415.677 754 415.923 754 415.923L754 391.144C754 391.144 757.887 395.351 759.994 398.844C762.101 402.337 764.789 409.031 764.789 409.031Z",
    fill: "#3E3E3E"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M767.279 404.105C767.279 404.105 761.573 398.689 758.98 395.402C756.387 392.115 754 387.272 754 387.272L780.559 400.805C780.559 400.805 778.172 403.215 775.579 403.86C772.986 404.504 767.279 404.105 767.279 404.105Z",
    fill: "#3E3E3E"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M767.111 390.539C767.111 390.539 761.859 385.407 759.473 382.266C757.087 379.125 754.891 374.454 754.891 374.454L779.33 386.906C779.33 386.906 777.134 389.339 774.748 390.049C772.362 390.758 767.111 390.539 767.111 390.539Z",
    fill: "#3E3E3E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.579 447.197C811.986 443.91 806.279 438.494 806.279 438.494C806.279 438.494 800.573 438.095 797.98 438.74C795.387 439.384 793 441.795 793 441.795L794.937 453.622L793 463.283L794.937 475.304L793 495.225L819.559 508.757L817.691 486.898L819.559 476.815L817.207 464.97L819.559 455.327C819.559 455.327 817.172 450.484 814.579 447.197Z",
    fill: "#3E3E3E"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M808.77 433.568C808.77 433.568 811.458 429.614 813.565 428.268C815.672 426.922 819.559 426.676 819.559 426.676L819.559 451.455C819.559 451.455 815.672 447.248 813.565 443.755C811.458 440.263 808.77 433.568 808.77 433.568Z",
    fill: "#3E3E3E"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M803.789 431.031C803.789 431.031 801.101 434.985 798.994 436.331C796.887 437.677 793 437.923 793 437.923L793 413.144C793 413.144 796.887 417.351 798.994 420.844C801.101 424.337 803.789 431.031 803.789 431.031Z",
    fill: "#3E3E3E"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M806.279 426.105C806.279 426.105 800.573 420.689 797.98 417.402C795.387 414.115 793 409.272 793 409.272L819.559 422.805C819.559 422.805 817.172 425.215 814.579 425.86C811.986 426.504 806.279 426.105 806.279 426.105Z",
    fill: "#3E3E3E"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M806.111 412.539C806.111 412.539 800.859 407.407 798.473 404.266C796.087 401.125 793.891 396.454 793.891 396.454L818.33 408.906C818.33 408.906 816.134 411.339 813.748 412.049C811.362 412.758 806.111 412.539 806.111 412.539Z",
    fill: "#3E3E3E"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.311 227.393C159.871 223.842 154.499 217.845 154.499 217.845C154.499 217.845 149.128 216.866 146.687 217.246C144.247 217.627 142 219.795 142 219.795L143.823 231.819L142 241.283L143.823 253.501L142 273.225L166.999 289.459L165.241 267.41L166.999 257.517L164.785 245.433L166.999 236.029C166.999 236.029 164.752 230.943 162.311 227.393Z",
    fill: "#3E3E3E"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M156.843 213.173C156.843 213.173 159.373 209.492 161.356 208.36C163.339 207.229 166.998 207.378 166.998 207.378L166.998 232.157C166.998 232.157 163.339 227.554 161.356 223.847C159.373 220.14 156.843 213.173 156.843 213.173Z",
    fill: "#3E3E3E"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M152.155 210.129C152.155 210.129 149.625 213.809 147.642 214.941C145.659 216.072 142 215.923 142 215.923L142 191.144C142 191.144 145.659 195.747 147.642 199.454C149.625 203.161 152.155 210.129 152.155 210.129Z",
    fill: "#3E3E3E"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M154.499 205.456C154.499 205.456 149.127 199.459 146.687 195.909C144.246 192.358 142 187.272 142 187.272L166.998 203.506C166.998 203.506 164.751 205.674 162.311 206.055C159.87 206.436 154.499 205.456 154.499 205.456Z",
    fill: "#3E3E3E"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M154.341 191.873C154.341 191.873 149.398 186.207 147.152 182.823C144.907 179.44 142.839 174.545 142.839 174.545L165.843 189.483C165.843 189.483 163.775 191.693 161.53 192.16C159.284 192.627 154.341 191.873 154.341 191.873Z",
    fill: "#3E3E3E"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.311 252.393C199.871 248.842 194.499 242.845 194.499 242.845C194.499 242.845 189.128 241.866 186.687 242.246C184.247 242.627 182 244.795 182 244.795L183.823 256.819L182 266.283L183.823 278.501L182 298.225L206.999 314.459L205.241 292.41L206.999 282.517L204.785 270.433L206.999 261.029C206.999 261.029 204.752 255.943 202.311 252.393Z",
    fill: "#3E3E3E"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M196.843 238.173C196.843 238.173 199.373 234.492 201.356 233.36C203.339 232.229 206.998 232.378 206.998 232.378L206.998 257.157C206.998 257.157 203.339 252.554 201.356 248.847C199.373 245.14 196.843 238.173 196.843 238.173Z",
    fill: "#3E3E3E"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M192.155 235.129C192.155 235.129 189.625 238.809 187.642 239.941C185.659 241.072 182 240.923 182 240.923L182 216.144C182 216.144 185.659 220.747 187.642 224.454C189.625 228.161 192.155 235.129 192.155 235.129Z",
    fill: "#3E3E3E"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M194.499 230.456C194.499 230.456 189.127 224.459 186.687 220.909C184.246 217.358 182 212.272 182 212.272L206.998 228.506C206.998 228.506 204.751 230.674 202.311 231.055C199.87 231.436 194.499 230.456 194.499 230.456Z",
    fill: "#3E3E3E"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M194.341 216.873C194.341 216.873 189.398 211.207 187.152 207.823C184.907 204.44 182.839 199.545 182.839 199.545L205.843 214.483C205.843 214.483 203.775 216.693 201.53 217.16C199.284 217.627 194.341 216.873 194.341 216.873Z",
    fill: "#3E3E3E"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.311 277.393C239.871 273.842 234.499 267.845 234.499 267.845C234.499 267.845 229.128 266.866 226.687 267.246C224.247 267.627 222 269.795 222 269.795L223.823 281.819L222 291.283L223.823 303.501L222 323.225L246.999 339.459L245.241 317.41L246.999 307.517L244.785 295.433L246.999 286.029C246.999 286.029 244.752 280.943 242.311 277.393Z",
    fill: "#3E3E3E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M236.843 263.173C236.843 263.173 239.373 259.492 241.356 258.36C243.339 257.229 246.998 257.378 246.998 257.378L246.998 282.157C246.998 282.157 243.339 277.554 241.356 273.847C239.373 270.14 236.843 263.173 236.843 263.173Z",
    fill: "#3E3E3E"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M232.155 260.129C232.155 260.129 229.625 263.809 227.642 264.941C225.659 266.072 222 265.923 222 265.923L222 241.144C222 241.144 225.659 245.747 227.642 249.454C229.625 253.161 232.155 260.129 232.155 260.129Z",
    fill: "#3E3E3E"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M234.499 255.456C234.499 255.456 229.127 249.459 226.687 245.909C224.246 242.358 222 237.272 222 237.272L246.998 253.506C246.998 253.506 244.751 255.674 242.311 256.055C239.87 256.436 234.499 255.456 234.499 255.456Z",
    fill: "#3E3E3E"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M234.341 241.873C234.341 241.873 229.398 236.207 227.152 232.823C224.907 229.44 222.839 224.545 222.839 224.545L245.843 239.483C245.843 239.483 243.775 241.693 241.53 242.16C239.284 242.627 234.341 241.873 234.341 241.873Z",
    fill: "#3E3E3E"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.311 302.393C278.871 298.842 273.499 292.845 273.499 292.845C273.499 292.845 268.128 291.866 265.687 292.246C263.247 292.627 261 294.795 261 294.795L262.823 306.819L261 316.283L262.823 328.501L261 348.225L285.999 364.459L284.241 342.41L285.999 332.517L283.785 320.433L285.999 311.029C285.999 311.029 283.752 305.943 281.311 302.393Z",
    fill: "#3E3E3E"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M275.843 288.173C275.843 288.173 278.373 284.492 280.356 283.36C282.339 282.229 285.998 282.378 285.998 282.378L285.998 307.157C285.998 307.157 282.339 302.554 280.356 298.847C278.373 295.14 275.843 288.173 275.843 288.173Z",
    fill: "#3E3E3E"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M271.155 285.129C271.155 285.129 268.625 288.809 266.642 289.941C264.659 291.072 261 290.923 261 290.923L261 266.144C261 266.144 264.659 270.747 266.642 274.454C268.625 278.161 271.155 285.129 271.155 285.129Z",
    fill: "#3E3E3E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M273.499 280.456C273.499 280.456 268.127 274.459 265.687 270.909C263.246 267.358 261 262.272 261 262.272L285.998 278.506C285.998 278.506 283.751 280.674 281.311 281.055C278.87 281.436 273.499 280.456 273.499 280.456Z",
    fill: "#3E3E3E"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M273.341 266.873C273.341 266.873 268.398 261.207 266.152 257.823C263.907 254.44 261.839 249.545 261.839 249.545L284.843 264.483C284.843 264.483 282.775 266.693 280.53 267.16C278.284 267.627 273.341 266.873 273.341 266.873Z",
    fill: "#3E3E3E"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.311 329.393C319.871 325.842 314.499 319.845 314.499 319.845C314.499 319.845 309.128 318.866 306.687 319.246C304.247 319.627 302 321.795 302 321.795L303.823 333.819L302 343.283L303.823 355.501L302 375.225L326.999 391.459L325.241 369.41L326.999 359.517L324.785 347.433L326.999 338.029C326.999 338.029 324.752 332.943 322.311 329.393Z",
    fill: "#3E3E3E"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M316.843 315.173C316.843 315.173 319.373 311.492 321.356 310.36C323.339 309.229 326.998 309.378 326.998 309.378L326.998 334.157C326.998 334.157 323.339 329.554 321.356 325.847C319.373 322.14 316.843 315.173 316.843 315.173Z",
    fill: "#3E3E3E"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M312.155 312.129C312.155 312.129 309.625 315.809 307.642 316.941C305.659 318.072 302 317.923 302 317.923L302 293.144C302 293.144 305.659 297.747 307.642 301.454C309.625 305.161 312.155 312.129 312.155 312.129Z",
    fill: "#3E3E3E"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M314.499 307.456C314.499 307.456 309.127 301.459 306.687 297.909C304.246 294.358 302 289.272 302 289.272L326.998 305.506C326.998 305.506 324.751 307.674 322.311 308.055C319.87 308.436 314.499 307.456 314.499 307.456Z",
    fill: "#3E3E3E"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M314.341 293.873C314.341 293.873 309.398 288.207 307.152 284.823C304.907 281.44 302.839 276.545 302.839 276.545L325.843 291.483C325.843 291.483 323.775 293.693 321.53 294.16C319.284 294.627 314.341 293.873 314.341 293.873Z",
    fill: "#3E3E3E"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.311 355.393C360.871 351.842 355.499 345.845 355.499 345.845C355.499 345.845 350.128 344.866 347.687 345.246C345.247 345.627 343 347.795 343 347.795L344.823 359.819L343 369.283L344.823 381.501L343 401.225L367.999 417.459L366.241 395.41L367.999 385.517L365.785 373.433L367.999 364.029C367.999 364.029 365.752 358.943 363.311 355.393Z",
    fill: "#3E3E3E"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M357.843 341.173C357.843 341.173 360.373 337.492 362.356 336.36C364.339 335.229 367.998 335.378 367.998 335.378L367.998 360.157C367.998 360.157 364.339 355.554 362.356 351.847C360.373 348.14 357.843 341.173 357.843 341.173Z",
    fill: "#3E3E3E"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M353.155 338.129C353.155 338.129 350.625 341.809 348.642 342.941C346.659 344.072 343 343.923 343 343.923L343 319.144C343 319.144 346.659 323.747 348.642 327.454C350.625 331.161 353.155 338.129 353.155 338.129Z",
    fill: "#3E3E3E"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M355.499 333.456C355.499 333.456 350.127 327.459 347.687 323.909C345.246 320.358 343 315.272 343 315.272L367.998 331.506C367.998 331.506 365.751 333.674 363.311 334.055C360.87 334.436 355.499 333.456 355.499 333.456Z",
    fill: "#3E3E3E"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M355.341 319.873C355.341 319.873 350.398 314.207 348.152 310.823C345.907 307.44 343.839 302.545 343.839 302.545L366.843 317.483C366.843 317.483 364.775 319.693 362.53 320.16C360.284 320.627 355.341 319.873 355.341 319.873Z",
    fill: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3713_16728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 423,
    y: 537,
    width: 200,
    height: 138
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 423.819,
    y: 537.442,
    width: 198.24,
    height: 136.565,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3713_16728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.809,
    y: 623.296,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.752,
    y: 536.722,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.721,
    y: 640.611,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.377,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.346,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.527,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.779,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.976,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.559,
    y: 623.296,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.502,
    y: 536.722,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.471,
    y: 640.611,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.127,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.096,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.277,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.53,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.726,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.309,
    y: 623.296,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.252,
    y: 536.722,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.221,
    y: 640.611,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.877,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.846,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.027,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.28,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.476,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.059,
    y: 623.296,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.002,
    y: 536.722,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.971,
    y: 640.611,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.627,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.596,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.777,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.03,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.226,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.81,
    y: 623.296,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.752,
    y: 536.722,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.721,
    y: 640.611,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.377,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.346,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.527,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.78,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.976,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#626262",
    stroke: "#C0C0C0",
    strokeWidth: 0.313605
  }))), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 520,
    width: 214.551,
    height: 17.6784,
    fill: "#7E7E7E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 570.922,
    width: 141.851,
    height: 103.085,
    fill: "#181818"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M459.062 572.684C459.062 572.684 519.599 577.258 548.93 609.37C575.489 638.448 581.529 674.007 581.529 674.007H459.062V572.684Z",
    fill: "#676767"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 570.922,
    width: 141.851,
    height: 1.76213,
    fill: "#C0C0C0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M452.895 570.922L461.705 572.67V674.007H452.895V570.922Z",
    fill: "#DDDDDD"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 665.196,
    width: 141.851,
    height: 8.81065,
    fill: "#333438"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M492.983 657.707C492.278 668.28 501.206 672.979 505.758 674.007H541.441C548.137 674.007 552.161 668.427 553.336 665.637C560.384 653.654 541.441 643.169 541.441 643.169C550.252 656.385 542.322 659.469 540.12 660.791C537.917 662.112 539.239 655.064 537.036 651.98C535.274 649.513 527.785 645.813 529.987 640.526C523.82 646.253 528.225 652.421 526.023 657.707C523.82 662.993 523.82 659.469 522.058 657.267C520.453 655.261 525.142 651.099 522.058 639.205C518.643 626.033 521.177 619.821 521.177 619.821C521.177 619.821 508.401 629.072 507.52 641.848C506.815 652.068 504.583 656.679 503.556 657.707C507.785 649.954 502.674 640.673 500.031 639.205C499.15 651.54 493.688 647.134 492.983 657.707Z",
    fill: "#CACACA",
    stroke: "#CACACA",
    strokeWidth: 0.808989,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M508.155 674.007C505.113 673.305 499.146 670.096 499.617 662.875C500.088 655.655 505.318 658.148 503.115 647.135C504.882 648.137 509.509 657.58 506.683 662.875C507.37 662.173 509.332 659.04 509.332 652.045C509.332 635.681 515.009 635.681 515.009 635.681C515.009 635.681 514.128 640.967 519.048 648.016C520.709 650.396 521.611 652.654 522.124 654.646C522.404 651.766 523.503 649.093 527.344 648.016C524.701 653.742 526.607 657.785 527.785 659.469C529.257 661.575 529.646 665.884 531.118 664.981C532.59 664.079 538.358 663.434 533.952 653.742C533.952 653.742 544.661 660.108 539.95 668.291C539.165 670.196 536.477 674.007 532.002 674.007H508.155Z",
    fill: "#9D9D9D",
    stroke: "#9D9D9D",
    strokeWidth: 0.808989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.417 663.8C519.368 662.242 521.527 661.827 523.241 662.873C523.336 662.931 523.427 662.992 523.516 663.056L523.523 663.045L533.111 668.897L533.104 668.908C534.607 670.003 535.108 671.967 534.21 673.438C533.313 674.909 531.336 675.361 529.676 674.526L529.669 674.537L529.403 674.375C529.398 674.372 529.392 674.368 529.387 674.365C529.382 674.362 529.376 674.359 529.371 674.355L520.08 668.685L520.087 668.674C519.99 668.625 519.893 668.571 519.798 668.513C518.085 667.468 517.466 665.357 518.417 663.8Z",
    fill: "#7B7B7B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520.954,
    cy: 665.348,
    rx: 3.192,
    ry: 3.30399,
    transform: "rotate(-148.604 520.954 665.348)",
    fill: "#4D4D4D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.428 671.143C530.428 672.968 528.801 674.447 526.794 674.447C526.682 674.447 526.572 674.443 526.463 674.434V674.447H515.577C515.572 674.447 515.566 674.447 515.56 674.447C515.554 674.447 515.549 674.447 515.543 674.447H515.23V674.434C513.377 674.282 511.926 672.867 511.926 671.143C511.926 669.42 513.377 668.005 515.23 667.853V667.839H526.463V667.853C526.572 667.844 526.682 667.839 526.794 667.839C528.801 667.839 530.428 669.319 530.428 671.143Z",
    fill: "#767676"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.014,
    cy: 671.143,
    rx: 3.63439,
    ry: 3.30399,
    fill: "#4F4F4F"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M849.853 473.768C847.443 469.646 842.227 461.982 842.227 461.982C842.227 461.982 837.09 458.66 834.76 457.73C832.43 456.659 830.307 457.27 830.307 457.27C830.932 461.852 831.547 466.594 832.182 471.497C831.646 474.918 831.121 478.39 830.595 481.892C831.22 487.035 831.825 491.987 832.459 496.759C831.934 503.433 831.388 509.886 830.823 516.199C838.479 528.615 846.402 542.612 854.861 558C854.613 546.954 854.098 535.989 853.453 525.124C853.979 520.641 854.484 516.119 855 511.537C854.177 505.694 853.354 500.021 852.551 494.498C853.195 490.566 853.146 489.542 853.8 486C853.8 486 852.253 477.81 849.853 473.768Z",
    fill: "#2B2B2B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M844.379 458.5C844.379 458.5 846.69 456.129 848.534 455.899C850.379 455.679 853.8 457.28 853.8 457.28C854.008 464.463 854.226 471.837 854.435 479.391C854.435 479.391 850.835 474.178 848.871 470.086C846.908 465.924 844.379 458.5 844.379 458.5Z",
    fill: "#2B2B2B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M839.877 453.728C839.877 453.728 837.537 455.999 835.653 456.049C833.768 456.029 830.288 453.568 830.288 453.568C830.208 446.134 830.129 438.86 830.06 431.747C830.06 431.747 833.53 437.67 835.454 441.952C837.388 446.224 839.877 453.728 839.877 453.728Z",
    fill: "#2B2B2B"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M842.029 450.506C842.029 450.506 836.843 442.682 834.502 438.35C832.162 433.998 830 428.455 830 428.455C837.864 437.18 845.787 445.644 853.701 453.938C853.701 453.938 851.658 454.888 849.377 454.248C847.096 453.598 842.029 450.506 842.029 450.506Z",
    fill: "#2B2B2B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M841.593 438.38C841.593 438.38 836.852 431.187 834.691 427.185C832.529 423.193 830.545 418 830.545 418C837.685 425.734 844.954 433.478 852.223 441.302C852.223 441.302 850.369 442.322 848.296 441.752C846.214 441.172 841.593 438.38 841.593 438.38Z",
    fill: "#2B2B2B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M870.099 468.505C872.539 473.727 877.886 483.79 877.886 483.79C877.886 483.79 883.182 488.482 885.572 489.742C887.952 491.035 892.5 488.001 892.5 488.001C882.5 477.759 873.765 466.715 865.319 457C865.319 457 867.597 463.432 870.099 468.505Z",
    fill: "#2B2B2B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M877.856 500.849C877.856 500.849 872.175 489.145 869.552 483.16C866.939 477.407 864.499 470.262 864.499 470.262C873.522 481.983 882.5 492 892.5 504.595C892.5 504.595 888.63 510.779 886.089 508.872C883.496 506.983 877.856 500.849 877.856 500.849Z",
    fill: "#2B2B2B"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M870.443 506.419C872.559 506.833 875.304 504.595 875.304 504.595C875.304 504.595 872.671 493.936 870.575 488.001C868.448 482.265 864.529 474.556 864.529 474.556C864.519 483.757 864.529 491.416 864.499 500.849L870.443 506.419Z",
    fill: "#2B2B2B"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M880.215 512.785C880.215 512.785 882.929 510.464 885.046 510.928C887.132 511.426 890.889 515.388 890.889 515.388C890.706 526.429 890.585 537.105 890.554 547.085C890.554 547.085 886.767 537.934 884.762 531.186C882.737 524.34 880.215 512.785 880.215 512.785Z",
    fill: "#2B2B2B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M885.704 536.723C883.192 529.628 877.653 516.498 877.653 516.498C877.653 516.498 871.992 510.099 869.4 508.259C866.797 506.469 864.134 504.595 864.134 504.595C864.711 509.569 865.613 516.896 866.19 521.986C865.491 524.655 864.823 527.241 864.134 529.81C864.681 535.348 865.187 541.166 865.684 547.234C864.833 554.379 863.942 561.673 863 569.051C873 591 883.5 606 889.309 619C888.975 609.07 888.6 599.256 888.165 589.524C888.914 585.579 889.623 581.666 890.352 577.787C889.592 572.416 888.843 566.929 888.114 561.392C888.944 558.043 889.765 554.777 890.565 551.611C890.565 551.611 888.195 543.554 885.704 536.723Z",
    fill: "#2B2B2B"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M926.913 584.883C923.889 579.044 917.288 568.669 917.288 568.669C917.288 568.669 910.775 565.295 907.821 564.914C904.866 564.534 902.148 566.712 902.148 566.712C902.899 572.395 903.65 578.026 904.401 583.603C903.663 587.361 902.926 591.066 902.188 594.719C902.926 600.296 903.657 608.338 904.401 614C903.631 621.834 902.853 627.164 902.049 634.835C912.142 650.474 922.285 678.529 932.733 695C932.068 682.908 929.198 656.543 928.5 644.5C929.231 639.571 932.275 636.904 933 631.905C932.078 625.193 931.149 618.568 930.213 612.032C931.096 607.491 931.966 603.025 932.822 598.632C932.822 598.632 929.966 590.71 926.913 584.883Z",
    fill: "#2B2B2B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M920.035 563.021C920.035 563.021 922.999 558.896 925.341 558.124C927.674 557.384 932.012 559.118 932.012 559.118C932.262 570.414 932.503 581.763 932.733 593.164C932.733 593.164 928.178 585.475 925.697 579.605C923.217 573.693 920.035 563.021 920.035 563.021Z",
    fill: "#2B2B2B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M914.353 556.971C914.353 556.971 911.358 561.191 908.957 562.048C906.575 562.894 902.138 561.329 902.138 561.329C902.105 549.653 902.066 537.959 902.02 526.247C902.02 526.247 906.427 534.211 908.819 540.208C911.24 546.226 914.353 556.971 914.353 556.971Z",
    fill: "#2B2B2B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M917.1 551.334C917.1 551.334 910.597 540.811 907.643 534.835C904.708 528.849 902 520.758 902 520.758C911.955 531.764 921.919 542.788 931.893 553.83C931.893 553.83 929.304 555.819 926.419 555.332C923.523 554.856 917.1 551.334 917.1 551.334Z",
    fill: "#2B2B2B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M916.685 532.265C916.685 532.265 910.765 522.238 908.077 516.527C905.39 510.795 902.919 503 902.919 503C911.984 513.252 921.053 523.599 930.124 534.042C930.124 534.042 927.772 536.146 925.144 535.776C922.515 535.427 916.685 532.265 916.685 532.265Z",
    fill: "#2B2B2B"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M972.968 643.205C969.635 637.392 962.279 627.198 962.279 627.198C962.279 627.198 954.88 623.916 951.536 623.336C948.182 622.526 945.108 624.096 945.108 624.096C945.935 630.292 946.769 636.669 947.61 643.225C946.769 647.8 945.935 652.406 945.108 657.041C945.928 664.131 946.751 671.294 947.578 678.531C946.693 688.855 943.949 697.242 943 707.5C954.275 726.829 966.827 753 979.299 774.5C978.479 758.46 978.084 735.042 977.206 719.249C977.969 712.526 978.724 705.763 979.471 698.96C978.407 690.556 977.35 682.356 976.3 674.359C977.286 668.409 978.285 662.674 979.299 657.151C979.299 657.151 976.279 648.957 972.968 643.205Z",
    fill: "#2B2B2B"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M965.698 620.895C965.698 620.895 969.236 616.013 972.018 614.652C974.801 613.262 979.957 613.902 979.957 613.902C979.813 626.067 979.669 638.409 979.525 650.928C979.525 650.928 974.553 643.555 971.867 637.632C969.16 631.7 965.698 620.895 965.698 620.895Z",
    fill: "#2B2B2B"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M959.237 615.362C959.237 615.362 955.753 619.764 953.025 620.545C950.307 621.165 945.28 618.804 945.28 618.804C945.28 607.919 945.27 597.161 945.248 586.53C945.248 586.53 950.274 593.703 953.014 599.255C955.753 604.908 959.237 615.362 959.237 615.362Z",
    fill: "#2B2B2B"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M962.484 609.31C962.484 609.31 955.052 599.675 951.676 594.213C948.311 588.801 945.28 576.565 945.28 576.565C956.5 589.961 968.287 599.415 980 608.219C980 608.219 976.797 611.141 973.356 611.421C969.948 611.641 962.484 609.31 962.484 609.31Z",
    fill: "#2B2B2B"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M962.139 589.961C962.139 589.961 955.236 581.467 952.097 576.565C948.991 571.753 947.75 559 947.75 559C957 567.5 967.5 578.5 978.307 587.29C978.307 587.29 975.373 590.421 972.18 590.942C969.02 591.462 962.139 589.961 962.139 589.961Z",
    fill: "#2B2B2B"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 995,
    y: 579,
    width: 7,
    height: 221,
    fill: "#767676"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M825 402L831 402L1002 579L995 579L825 402Z",
    fill: "#B0B0B0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3713_16728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 550,
    y: 110,
    width: 109,
    height: 82
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 110,
    width: 108.091,
    height: 82,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3713_16728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.392,
    y: 146.986,
    width: 12.3287,
    height: 11.1818,
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.361 176.804C647.705 175.657 647.504 168.967 647.361 165.766L639.906 168.92L641.483 178.955V184.832C641.483 188.158 642.534 193.099 643.06 195.154L648.077 194.724C649.368 188.416 647.791 182.682 647.361 181.965C646.93 181.248 646.93 178.238 647.361 176.804Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.794 163.902L614.675 169.35C614.436 171.835 613.93 176.89 613.815 177.234C613.672 177.664 613.385 183.255 613.242 183.972C613.127 184.545 610.231 190.805 608.798 193.864C607.268 194.676 604.153 195.727 603.923 193.434C603.637 190.566 606.361 180.962 606.504 180.675C606.647 180.388 606.934 178.955 607.794 177.234C608.482 175.858 608.081 167.773 607.794 163.902Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.784,
    y: 145.839,
    width: 12.3287,
    height: 9.74825,
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.574 178.955C591.23 178.152 590.379 170.497 589.997 166.769C589.997 165.278 594.68 164.237 597.021 163.902C596.907 165.049 597.547 174.033 597.882 178.381C598.885 179.815 599.602 184.832 600.032 186.266C600.376 187.413 600.462 191.713 600.462 193.72H594.298C594.154 193.147 592.864 188.99 592.721 187.556C592.577 186.122 592.004 179.958 591.574 178.955Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.892 164.332C560.58 164.676 562.664 166.1 563.619 166.769C562.807 171.596 561.182 181.392 561.182 181.965V185.836V193.72H555.161C554.731 193.003 554.588 187.556 554.588 185.836C554.588 184.115 555.161 178.955 555.591 177.521C556.021 176.087 555.591 166.339 555.591 166.052C555.591 165.766 559.032 163.902 559.892 164.332Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.773 153.595C577.015 153.117 579.787 151.932 580.934 151.015C582.081 150.097 586.955 151.493 589.248 152.305C590.539 152.878 593.291 154.025 593.979 154.025C594.839 154.025 599.57 157.036 599.283 159.186C598.997 161.336 598.28 162.77 597.706 162.77C597.133 162.77 594.839 161.91 593.119 163.487C591.399 165.064 589.535 164.777 589.822 166.354C590.108 167.931 591.542 170.655 590.395 171.515C589.478 172.203 590.682 174.286 591.399 175.242C591.255 176.006 590.854 177.593 590.395 177.822C589.822 178.109 590.395 180.259 590.395 180.403C590.395 180.517 591.733 181.597 592.402 182.123C593.406 186.185 595.384 194.538 595.269 195.455L561.007 195.885C560.915 191.643 561.081 183.014 562.432 181.281C562.769 180.606 563.444 178.969 563.444 177.822C563.444 176.389 562.28 173.092 562.432 171.515C562.584 169.938 564.448 167.214 564.448 166.784C564.448 166.44 563.205 165.972 562.584 165.78C561.103 164.968 557.71 163.687 555.99 165.064C555.607 165.207 554.843 165.178 554.843 163.917C554.843 162.34 554.269 160.906 554.843 159.616C555.416 158.326 557.423 156.749 557.997 156.319C558.57 155.889 559.717 154.168 561.581 154.599C563.444 155.029 567.458 154.455 567.601 154.025C567.716 153.681 569.274 152.257 570.039 151.588C571.472 152.454 574.626 154.067 575.773 153.595Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.236 165.059C590.465 163.797 591.287 163.864 591.67 164.055C591.67 163.816 591.842 163.339 592.53 163.339C593.39 163.339 593.247 163.052 594.393 162.335C595.54 161.618 595.11 161.618 596.83 161.618C598.551 161.618 597.404 161.762 598.551 161.618C599.698 161.475 600.558 162.909 600.701 164.055C600.844 165.202 598.981 164.485 598.551 165.059C598.121 165.632 597.691 165.059 596.83 165.059C595.97 165.059 595.827 166.206 595.11 166.636C594.393 167.066 593.82 166.636 592.817 166.636C591.813 166.636 591.096 168.069 590.236 168.213C589.376 168.356 589.949 166.636 590.236 165.059Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.988 163.339C560.363 163.339 560.636 163.667 560.807 164C561.246 164.264 561.808 164.485 562.425 164.485C563.858 164.485 563.858 165.632 564.145 166.062C564.432 166.492 563.142 168.213 562.855 167.066C562.568 165.919 561.851 166.062 561.421 165.632C560.991 165.202 559.988 166.062 558.984 166.062C557.981 166.062 556.834 166.636 555.687 167.639C554.54 168.643 554.254 167.066 553.393 166.062C552.533 165.059 554.11 164.485 556.261 164.485C557.264 164.485 556.834 164.055 558.984 164.485C559.701 164.916 559.271 163.339 559.988 163.339Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.714 177.531C590.809 178.439 591.038 179.911 590.714 179.928C589.328 180.001 584.463 179.907 578.624 179.898C579.245 184.365 580.621 195.355 580.392 196.157L573.081 195.871C572.938 191.4 573.119 180.794 573.463 180.398C573.893 179.903 571.456 180.892 571.026 179.928C567.079 179.98 564.007 180.107 563.715 180.398C562.425 180.398 562.167 179.366 562.855 177.531C564.658 177.414 567.588 177.07 570.664 176.83C570.861 176.457 571.201 176.145 571.743 175.954C574.18 175.094 574.467 176.607 574.754 176.599C575.87 176.568 577.036 176.572 578.216 176.602C579.186 175.963 580.253 175.372 580.631 175.524C580.889 175.627 581.22 176.127 581.493 176.742C585.009 176.947 588.381 177.298 590.714 177.531Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.224 131.867C566.256 125.559 571.293 123.026 573.682 122.549C573.348 122.166 573.74 121.631 577.983 122.549C583.287 123.695 582.857 126.563 585.151 129.43C587.444 132.297 587.444 137.171 587.588 137.744C587.731 138.318 588.305 141.615 589.738 142.475C591.172 143.335 592.319 146.653 592.749 149.643C593.179 152.633 587.588 155.664 586.298 155.664C585.007 155.664 584.434 154.66 582.284 153.8C580.133 152.94 579.99 150.646 580.498 148.926C580.905 147.55 580.667 146.837 580.498 146.653H571.675C571.675 146.653 570.815 150.933 570.242 152.94C569.668 154.947 565.798 155.521 563.074 155.664C560.35 155.807 560.063 150.79 559.777 148.926C559.49 147.063 561.497 145.056 563.074 144.769C564.651 144.482 563.934 139.751 565.224 131.867Z",
    fill: "#5A5A5A",
    stroke: "#5A5A5A",
    strokeWidth: 0.286713,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.964 130.653C576.014 130.309 574.666 129.076 574.236 128.502C571.369 127.642 570.222 130.653 569.219 131.656C568.215 132.66 568.215 137.534 568.072 139.397C567.929 141.261 569.649 146.278 569.792 146.995C569.936 147.712 573.806 151.296 574.236 151.296C574.666 151.296 576.96 151.439 577.533 151.296C578.107 151.153 582.121 147.139 582.551 146.278C582.981 145.418 583.698 139.971 583.698 139.397C583.698 138.824 582.981 133.806 582.981 133.233C582.981 132.66 580.401 131.083 577.964 130.653Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.095 137.017C577.908 136.635 579.762 135.985 580.679 136.444C581.157 136.539 582.113 136.788 582.113 137.017M574.228 136.587C573.32 136.348 571.332 135.928 570.644 136.157C569.956 136.386 569.784 136.539 569.784 136.587",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.099 138.241C578.673 137.907 580.049 137.496 580.966 138.528M570.645 137.955C571.218 137.62 572.594 137.209 573.512 138.241",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.077,
    cy: 138.098,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.532,
    cy: 138.385,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.945 142.399C575.089 142.59 575.433 142.972 575.662 142.972C575.891 142.972 576.236 142.59 576.379 142.399",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.081 145.552C574.228 145.983 576.092 146.499 577.812 146.269",
    stroke: "#5A5A5A",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.654 146.269C574.801 146.699 575.088 146.699 576.521 146.843",
    stroke: "#8B8B8B",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 583.819,
    cy: 132.061,
    rx: 1.0035,
    ry: 1.72028,
    transform: "rotate(-28.6973 583.819 132.061)",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.271 132.441C622.074 130.721 625.046 130.004 626.432 129.861C629.013 129.247 634.46 132.441 635.033 133.445C635.607 134.448 635.177 139.179 635.32 140.326C635.464 141.473 634.46 144.627 634.46 146.06C634.46 147.494 630.733 150.361 630.159 150.934C629.586 151.508 626.862 151.364 625.715 150.934C624.568 150.504 621.271 146.347 620.985 145.343C620.698 144.34 620.124 139.322 620.268 138.319C620.411 137.315 620.268 134.592 621.271 132.441Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.982 143.975C627.221 144.214 627.842 144.549 628.416 143.975M629.563 139.675C629.993 139.245 631.225 138.643 632.716 139.675M625.262 139.675C624.832 139.197 623.685 138.528 622.538 139.675",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.118 146.953C626.265 146.761 628.817 146.494 629.849 146.953",
    stroke: "#676767",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 631.14,
    cy: 139.531,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.972,
    cy: 139.531,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.7 156.734C607.865 158.11 607.502 160.462 607.55 161.465V162.038C607.789 162.325 608.439 162.956 609.127 163.185C609.987 163.472 611.421 164.476 611.564 165.336C611.707 166.196 612.711 167.056 613.714 167.343C614.718 167.629 615.148 168.776 614.718 170.497C614.288 172.217 613.427 177.234 613.284 177.664C613.169 178.008 614.479 179.815 615.148 180.675V182.538C615.148 182.73 614.861 183.227 613.714 183.685C612.281 184.259 608.983 194.437 609.127 194.867C609.27 195.297 643.102 195.01 643.102 194.437C643.102 193.864 641.669 185.979 641.669 185.262C641.669 184.545 640.809 183.685 640.379 183.112C639.948 182.538 640.809 180.245 641.669 179.671C642.529 179.098 641.955 177.091 642.386 175.514C642.816 173.937 640.522 170.21 640.379 168.776C640.235 167.343 641.382 167.486 641.955 166.626C642.529 165.766 644.106 165.622 644.393 165.336C644.679 165.049 645.539 166.196 646.543 166.196C647.546 166.196 647.403 164.332 647.403 163.902C647.403 163.472 647.546 161.465 646.973 159.745C646.514 158.369 644.201 157.164 643.102 156.734C642.003 155.444 639.49 152.72 638.228 152.147C636.651 151.43 633.784 151.573 633.497 152.147C633.211 152.72 630.057 154.01 627.62 154.154C625.67 154.269 623.176 152.099 622.172 151C621.647 151.048 620.595 151.229 620.595 151.573C620.595 152.003 617.011 154.871 616.725 154.871C616.438 154.871 615.578 155.301 613.714 154.871C611.851 154.441 611.994 155.014 609.7 156.734Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.546 137.5C624.546 137.5 624.197 136.907 623.546 137C622.895 137.093 621.74 137.55 621.546 137.938M629.046 137.5C629.472 137.384 631.325 136.568 632.046 137C632.511 137.279 632.813 137.821 633.046 137.938",
    stroke: "black",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.336 129.972C625.107 129.628 625.145 128.587 625.336 128.109C625.336 126.916 627.343 125.769 631.214 126.916C635.084 128.063 637.447 133.7 637.877 134.13C638.221 134.474 638.881 142.062 639.598 144.738C640.075 146.841 641.478 149.24 643.542 150.616C646.123 152.336 645.263 154.63 644.403 156.637C643.542 158.644 639.098 157.64 638.525 157.784C637.952 157.927 637.808 158.787 635.371 158.787C633.422 158.787 633.316 157.354 633.508 156.637C633.03 156.207 631.902 155.06 631.214 153.913C630.526 152.766 630.927 151.237 631.214 150.616C631.787 149.134 633.049 145.885 633.508 144.738C634.081 143.305 634.798 135.993 634.511 134.13C634.224 132.266 633.077 132.553 631.214 131.836C629.35 131.119 625.623 130.402 625.336 129.972Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.476 130.259L624.763 128.539C624.906 127.679 624.688 126.629 623.398 127.203C622.108 127.776 620.244 128.826 618.954 130.259C617.664 131.693 616.804 137.524 616.804 139.101C616.804 140.678 615.084 143.115 615.084 144.262C615.084 145.409 615.084 147.703 615.657 148.563C616.23 149.423 617.165 150.857 616.878 151.573C616.591 152.29 615.301 153.913 615.301 153.053C615.301 152.193 616.305 153.483 615.301 152.049C615.301 151.046 613.868 152.336 613.438 153.053C613.008 153.77 614.584 155.347 614.584 155.777C614.584 156.207 616.018 157.497 617.308 157.497C618.598 157.497 619.315 156.637 619.459 156.637C619.602 156.637 621.035 154.916 622.039 153.913C623.042 152.909 622.899 150.042 622.756 148.895C622.612 147.749 620.175 141.011 620.175 139.291C620.175 137.57 620.605 134.13 621.466 132.553C622.154 131.291 623.759 130.498 624.476 130.259Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.28 164.832C644.706 165.405 644.288 165.262 643.857 164.832C642.854 165.357 640.646 166.552 639.843 167.125C638.84 167.842 639.987 168.416 640.56 169.419C641.134 170.423 641.564 168.846 642.137 168.416C642.711 167.986 642.567 167.842 643.857 167.842C645.148 167.842 645.291 167.842 646.008 167.125C646.725 166.409 646.868 166.695 647.298 166.695C647.728 166.695 648.158 167.556 648.875 167.842C649.592 168.129 649.735 167.556 649.735 166.695C649.735 165.835 650.308 166.265 651.025 165.979C651.742 165.692 650.022 164.832 649.735 164.258C649.448 163.685 648.732 163.255 647.728 163.111C646.725 162.968 646.008 163.398 646.008 164.258C646.008 165.118 645.853 164.258 645.28 164.832Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.462 164.258C611.774 163.8 611.411 164.449 611.315 164.832C611.077 164.497 610.599 163.771 610.599 163.542C610.599 163.255 609.308 162.538 609.308 162.108C609.308 161.678 608.735 162.681 607.732 162.538C606.728 162.395 606.585 163.828 606.155 164.258C605.725 164.688 606.298 165.979 606.585 166.695C606.871 167.412 607.588 166.695 608.305 165.979C609.022 165.262 608.735 164.832 608.735 164.258C608.735 163.685 609.308 164.832 609.308 165.405C609.308 165.979 609.739 165.979 610.599 166.695C611.459 167.412 611.315 167.125 611.889 167.842C612.462 168.559 612.892 168.846 613.896 168.846C614.899 168.846 614.899 168.416 614.899 167.125C614.899 165.835 613.753 165.979 613.322 165.979C612.892 165.979 613.322 164.832 612.462 164.258Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.329 182.321C615.1 182.092 614.947 180.697 614.899 180.028C616.711 179.76 618.818 179.604 621.026 179.527C621.123 179.061 621.237 178.707 621.35 178.594C621.569 178.375 622.993 178.878 624.42 179.469C626.389 179.466 628.36 179.512 630.202 179.588C630.625 179.102 631.135 178.594 631.959 178.594C632.985 178.594 632.918 179.063 632.826 179.718C636.729 179.947 639.604 180.278 639.843 180.458C640.302 180.802 640.035 182.799 639.843 183.755C639.557 183.659 638.783 183.353 637.98 182.895C637.523 182.634 635.312 182.581 632.769 182.614C632.598 183.344 632.279 184.008 631.959 184.328C631.385 184.902 630.382 183.755 630.382 184.328V187.052C630.382 187.74 631.433 194.064 631.959 195.976C629.522 196.119 624.648 195.89 624.648 195.545C624.648 195.115 625.221 190.636 625.364 187.625C625.477 185.255 626.479 183.615 626.69 182.799C625.86 182.835 625.152 182.869 624.648 182.895C624.274 182.913 623.843 182.922 623.377 182.923C622.199 183.243 621.113 183.518 620.92 183.325C620.85 183.254 620.802 183.09 620.774 182.863C618.155 182.752 615.515 182.507 615.329 182.321Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 635.14,
    cy: 133.494,
    rx: 1.0035,
    ry: 1.72028,
    transform: "rotate(-28.6973 635.14 133.494)",
    fill: "#9B9B9B"
  }))), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 678,
    width: 81,
    height: 10,
    fill: "#424242"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 681,
    cy: 683,
    r: 7,
    fill: "#D8D8D8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 684,
    r: 10,
    fill: "#D8D8D8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.483 674C735.41 676.165 736 679.412 736 683.04C736 686.624 735.425 689.835 734.517 692C733.59 689.835 733 686.588 733 682.96C733 679.376 733.575 676.165 734.483 674Z",
    fill: "#1C1C1C"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.483 674C684.41 675.804 685 678.51 685 681.534C685 684.52 684.425 687.196 683.517 689C682.59 687.196 682 684.49 682 681.466C682 678.48 682.575 675.804 683.483 674Z",
    fill: "#1C1C1C"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M670.84 722.015C668.124 713.545 669.085 702.31 670.156 696.44C670.249 695.932 670.85 695.72 671.251 696.046L673.776 698.099C674.28 698.509 674.24 700.024 673.974 700.616C672.363 704.196 671.956 714.465 671.973 721.794C671.975 722.536 671.067 722.722 670.84 722.015Z",
    fill: "#C4C4C4"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M765.155 717.763C762.97 711.527 763.397 704.956 764.249 700.702C764.313 700.384 764.594 700.16 764.918 700.16H768.108C768.581 700.16 768.931 700.625 768.818 701.085C768.118 703.954 766.742 711.568 766.414 717.523C766.373 718.258 765.398 718.458 765.155 717.763Z",
    fill: "#C4C4C4"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M736.161 726.921C733.11 718.634 733.679 709.771 734.797 704.154C734.861 703.834 735.142 703.608 735.468 703.608H739.839C740.31 703.608 740.656 704.07 740.543 704.528C739.661 708.097 737.77 718.744 737.435 726.673C737.404 727.412 736.417 727.615 736.161 726.921Z",
    fill: "#C4C4C4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M703.437 660.821C703.47 660.814 703.504 660.812 703.538 660.815L775.104 666.259C775.547 666.293 775.585 666.928 775.149 667.014L747.459 672.478C747.428 672.484 747.397 672.486 747.366 672.485L666.738 668.562C666.287 668.54 666.242 667.89 666.686 667.806L703.437 660.821L703.36 660.411L703.437 660.821Z",
    fill: "#787878",
    stroke: "#7C7C7C",
    strokeWidth: 0.834369
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M665.602 682.368C665.648 681.462 666.456 680.778 667.363 680.877C698.192 684.243 716.555 685.111 747.898 684.929C748.809 684.923 749.542 685.685 749.497 686.589L748.583 704.725C748.539 705.597 747.797 706.267 746.926 706.224L666.187 702.156C665.316 702.112 664.645 701.37 664.689 700.499L665.602 682.368Z",
    fill: "#8E8E8E",
    stroke: "#7A7A7A",
    strokeWidth: 0.834369
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M666.649 668.614C666.699 667.615 667.663 666.891 668.656 667.109C672.008 667.846 678.502 669.098 685.74 669.568C688.855 669.771 690.544 669.588 692.796 669.344C692.908 669.332 693.022 669.319 693.138 669.307C695.551 669.047 698.717 668.735 704.957 668.735C711.179 668.735 714.905 669.379 718.276 670.065C718.65 670.141 719.019 670.217 719.387 670.294C722.356 670.909 725.252 671.509 729.557 671.655C737.811 671.933 745.143 671.406 748.751 671.071C749.739 670.979 750.586 671.783 750.537 672.764L750.019 683.051C749.966 684.098 748.927 684.818 747.919 684.504C743.484 683.12 734.081 680.389 728.021 680.083C720.766 679.718 715.01 680.543 709.583 681.32C708.099 681.533 706.639 681.742 705.181 681.922C698.391 682.761 691.549 682.99 682.122 680.101C679.917 679.425 677.292 679.323 674.809 679.472C672.319 679.622 669.94 680.027 668.21 680.387C667.121 680.613 666.087 679.754 666.142 678.676L666.649 668.614Z",
    fill: "#8E8E8E",
    stroke: "#7A7A7A",
    strokeWidth: 0.834369
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M750.338 672.426C750.389 671.695 750.936 671.095 751.659 670.977L777.196 666.8C778.195 666.637 779.087 667.442 779.028 668.452L777.274 698.222C777.233 698.921 776.736 699.51 776.053 699.668L750.048 705.683C749.013 705.923 748.041 705.093 748.115 704.033L750.338 672.426Z",
    fill: "#8E8E8E",
    stroke: "#7A7A7A",
    strokeWidth: 0.834369
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M709.846 562.761C709.873 562.325 710.082 561.914 710.42 561.637C734.174 542.106 763.772 549.082 786.098 568.343C786.292 568.51 786.393 568.761 786.371 569.016L777.861 665.216C777.824 665.645 777.453 665.967 777.023 665.944L704.501 662.034C704.058 662.01 703.72 661.63 703.747 661.187L709.846 562.761Z",
    fill: "#6A6A6A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694.242 561.332C699.548 556.689 701.719 557.503 704.449 558.526C705.007 558.735 705.589 558.953 706.225 559.135C708.413 559.76 710.844 561.118 711.8 561.68C712.058 561.832 712.201 562.119 712.176 562.417L704.123 658.688V661.663C704.123 662.064 703.825 662.403 703.427 662.455L672.126 666.524C671.628 666.589 671.194 666.183 671.225 665.682L671.515 661.017C671.54 660.612 671.256 660.258 670.868 660.137C667.927 659.216 665.751 655.925 665.751 652.005C665.751 647.372 668.791 643.617 672.541 643.617C672.85 643.617 673.154 643.642 673.452 643.692C673.499 643.699 673.546 643.704 673.593 643.704H688.4C688.817 643.704 689.163 643.388 689.196 642.973C690.423 627.43 692.16 605.011 692.644 596.683C692.934 591.698 692.389 586.431 691.876 581.472C690.968 572.706 690.16 564.904 694.242 561.332Z",
    fill: "#8E8E8E"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.578 562.484C780.774 558.01 788.701 564.938 790.279 566.412C790.459 566.58 790.539 566.822 790.508 567.067L778.068 665.201C778.016 665.617 777.65 665.921 777.232 665.898L775.507 665.802C775.05 665.777 774.664 666.141 774.664 666.6V667.98C774.664 668.421 774.307 668.778 773.865 668.778H757.098C756.872 668.778 756.689 668.596 756.689 668.37C756.689 668.131 756.485 667.943 756.247 667.962C756.087 667.975 755.925 667.988 755.762 668C751.255 668 746 661.669 746 659.53C746 649.725 753.544 649 758.05 649C759.403 649 760.679 649.316 761.802 649.876C762.32 650.134 762.983 649.868 763.093 649.3C765.985 634.47 770.077 612.89 771.584 602.029C772.514 595.321 772.418 588.473 772.331 582.345C772.201 573.093 772.094 565.484 775.578 562.484Z",
    fill: "#8E8E8E"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M752.1 655.927C752.138 655.405 752.574 655 753.098 655H777C777.552 655 778 655.448 778 656V667.117C778 667.627 777.617 668.055 777.11 668.111L752.195 670.868C751.573 670.937 751.042 670.425 751.088 669.801L752.1 655.927Z",
    fill: "#8E8E8E"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.277 746.104C632.242 746.104 623.342 757.914 602.042 757.914C579.375 757.914 561 751.933 561 744.556C561 739.019 571.35 734.269 586.096 732.243C591.975 730.23 581.908 728.47 581.908 726.358C581.908 718.98 600.283 713 622.95 713C645.617 713 663.992 718.98 663.992 726.358C663.992 728.104 662.963 729.771 661.092 731.3C656.441 733.714 677.543 735.736 677.543 740.297C677.543 745.322 668.876 749.395 658.184 749.395C651.963 749.395 647.923 746.104 643.277 746.104ZM639.086 738.798L638.895 738.67L639.146 738.635L639.086 738.798Z",
    fill: "#565656"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.6156,
    ry: 4.45265,
    transform: "matrix(1 0 0 -1 682.964 729.455)",
    fill: "#565656"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.13092,
    ry: 3.09749,
    transform: "matrix(1 0 0 -1 691.869 741.652)",
    fill: "#565656"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1043.84,
    y1: 465.754,
    x2: 1198.84,
    y2: 569.754,
    stroke: "#949494",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3713_16728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 27,
    width: 118,
    height: 151
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 27,
    width: 118,
    height: 150.694,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3713_16728)"
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M400.853 91.0731C403.296 89.9458 405.864 83.3067 406.49 80.175C410.418 88.5037 418.421 88.5526 420.716 87.2464C420.966 86.2231 421.202 85.7153 421.334 86.3757C421.395 86.6832 421.165 86.9908 420.716 87.2464C420.254 89.135 419.743 92.7796 419.743 94.0795L411.663 97.0859C408.845 96.1464 399.261 91.8077 400.853 91.0731Z",
    fill: "#C4C4C4"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M417.986 56.7117C416.671 56.3359 413.665 56.0352 412.162 57.8391C410.283 60.0938 408.779 61.2212 407.652 66.8582C406.75 71.3677 403.894 71.9941 402.579 71.7435C402.704 73.1214 404.761 78.8973 406.114 80.5508C407.805 82.6177 404.389 87.3152 402.92 88.0668C401.451 88.8184 397.095 89.9458 393.901 86.1878C390.707 82.4298 389.426 78.6958 390.929 77.9442C392.132 77.3429 391.555 77.4431 391.117 77.5684C390.24 76.441 389.013 73.6977 391.117 71.7435C393.748 69.3008 393.56 68.1735 394.499 66.8582C394.75 64.9166 395.815 60.3945 398.069 57.8391C400.888 54.6448 402.015 52.9537 403.706 52.7658C405.397 52.5779 409.531 49.0079 416.483 51.6384C417.49 52.0195 418.241 52.3159 418.786 52.5429C420.306 52.1703 422.557 51.8871 423.436 52.7658C424.751 54.0811 427.569 55.9601 427.193 59.5302C426.818 63.1002 427.757 66.2945 427.193 66.8582C426.743 67.3091 426.129 67.0461 425.878 66.8582C425.941 65.1671 425.841 61.5219 424.939 60.4697C423.811 59.1544 422.496 56.7117 420.241 56.7117H417.986Z",
    fill: "#4D4D4D"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M400.102 90.1345C401.304 90.2848 406.365 93.454 408.745 95.0198C409.747 93.3914 411.977 90.1345 412.879 90.1345C414.006 90.1345 421.522 88.2555 424.904 86.7523C428.286 85.2491 430.917 88.6313 435.051 90.1345C439.184 91.6377 437.681 96.3351 438.057 98.2141C438.433 100.093 440.312 110.615 442.379 112.87C444.446 115.125 445.009 126.775 450.458 132.412C455.907 138.048 458.35 155.711 459.477 157.966C460.605 160.22 466.993 162.287 468.872 166.421C470.376 169.728 464.488 177.946 461.356 181.641H353.503C357.825 181.453 363.649 164.354 366.28 162.287C368.911 160.22 366.656 143.31 366.28 140.679C365.904 138.048 370.602 123.58 373.232 119.634C375.863 115.689 385.446 107.985 385.634 107.045C385.821 106.106 389.391 97.4625 392.022 95.0198C394.653 92.5772 398.598 89.9466 400.102 90.1345Z",
    fill: "#4E4E4E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M398.914 53.6441C402.753 50.2767 409.354 48.5141 412.899 49.6004C417.407 49.707 421.509 49.3891 426.129 52.6936C430.75 55.9981 433.485 70.0619 435.672 72.9329C437.859 75.8039 442.651 87.7582 443.506 91.3494C444.361 94.9407 451.556 116.537 453.332 120.902C455.108 125.267 459.122 138.331 461.484 141.77C463.846 145.209 465.923 152.776 466.612 155.423C467.301 158.071 465.066 165.16 465.567 167.803C466.068 170.447 464.079 175.098 463.847 176.972C463.661 178.472 462.171 176.306 461.449 175.036C459.993 173.047 456.985 162.463 455.663 157.42L446.482 132.393C444.534 132.66 439.366 132.864 434.285 131.541C427.934 129.887 421.11 132.357 420.349 132.715C419.613 133.061 413.159 136.796 412.904 137.719C412.902 137.747 412.901 137.774 412.899 137.801C413.035 138.406 414.709 138.094 415.529 137.863C415.035 139.656 410.759 140.883 408.682 141.272C396.825 141.932 397.121 145.322 394.42 148.265C391.719 151.208 392.212 154.227 390.857 155.887C389.91 157.046 387.284 157.679 385.63 157.922C385.602 157.952 385.573 157.984 385.544 158.016C383.035 160.776 382.553 165.276 381.39 166.752C380.46 167.933 378.561 169.817 377.728 170.612C377.521 171.422 376.872 173.411 375.935 174.893C374.763 176.744 370.922 180.225 369.008 181.683C367.094 183.141 365.949 183.866 364.796 184.966C363.642 186.067 338.51 183.781 339.262 183.798C340.013 183.816 341.377 181.781 343.461 181.078C345.545 180.376 358.515 148.543 358.904 147.989C359.293 147.434 364.345 132.517 364.971 129.901C365.178 129.034 366.682 125.192 368.672 120.431C369.114 118.886 369.835 116.994 370.595 114.622C382.627 77.0335 389.385 74.6964 392.962 66.5112C396.538 58.326 394.116 57.8535 398.914 53.6441Z",
    fill: "#757575",
    fillOpacity: 0.4
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M412.899 137.801C413.035 138.406 414.709 138.094 415.529 137.863C415.035 139.656 410.759 140.883 408.682 141.272C396.825 141.932 397.121 145.322 394.42 148.265C391.719 151.208 392.212 154.227 390.857 155.887C389.773 157.214 386.487 157.851 384.98 158.003C386.004 157.087 387.551 155.808 385.544 158.016C383.035 160.776 382.553 165.276 381.39 166.752C380.46 167.933 378.561 169.817 377.728 170.612C377.521 171.422 376.872 173.411 375.935 174.893C374.763 176.744 370.922 180.225 369.008 181.683C367.094 183.141 365.949 183.866 364.796 184.966C363.642 186.067 338.51 183.781 339.262 183.798C340.013 183.816 341.377 181.781 343.461 181.078C345.545 180.376 358.515 148.543 358.904 147.989C359.293 147.434 364.345 132.517 364.971 129.901C365.471 127.808 373.532 108.378 377.728 100.521C377.697 101.836 373.315 112.055 372.702 114.108C372.212 115.75 369.412 120.546 368.23 122.836C368.274 120.957 369.386 118.397 370.595 114.622C382.627 77.0335 389.385 74.6964 392.962 66.5112C396.538 58.326 394.116 57.8535 398.914 53.6441C402.753 50.2767 409.354 48.5141 412.899 49.6004C417.407 49.707 421.509 49.3891 426.129 52.6936C430.75 55.9981 433.485 70.0619 435.672 72.9329C437.859 75.8039 442.651 87.7582 443.506 91.3494C444.361 94.9407 451.556 116.537 453.332 120.902C455.108 125.267 459.122 138.331 461.484 141.77C463.846 145.209 465.923 152.776 466.612 155.423C467.301 158.071 465.066 165.16 465.567 167.803C466.068 170.447 464.079 175.098 463.847 176.972C463.661 178.472 462.171 176.306 461.449 175.036C459.993 173.047 456.985 162.463 455.663 157.42L446.482 132.393M412.899 137.801C412.729 137.045 419.589 133.073 420.349 132.715C421.11 132.357 427.934 129.887 434.285 131.541C439.366 132.864 444.534 132.66 446.482 132.393M412.899 137.801C413.206 132.52 413.008 119.797 412.008 111.203C410.759 100.46 409.536 88.5905 411.123 85.057M446.482 132.393C443.292 124.461 436.559 105.92 435.145 95.2107C433.378 81.8244 426.854 63.6268 426.129 62.482M396.224 71.9997C393.329 85.588 387.772 117.154 388.71 134.71",
    stroke: "#070707",
    strokeOpacity: 0.35,
    strokeWidth: 0.375796
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M430.615 150.139C430.624 150.13 430.633 150.121 430.642 150.112C434.014 146.842 441.134 138.977 442.863 133.449C444.596 127.906 439.449 103.412 438.057 98.965C439.671 101.816 448.978 114.982 450.27 118.131C451.677 122.37 452.512 137.89 453.089 140.49C453.809 143.741 446.142 154.434 445.966 157.021C445.79 159.608 438.999 165.302 439.095 163.899L439.375 159.775C435.941 148.639 432.142 148.681 430.642 150.112C430.633 150.121 430.624 150.13 430.615 150.139Z",
    fill: "#292929"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M430.615 150.139C430.624 150.13 430.633 150.121 430.642 150.112C434.014 146.842 441.134 138.977 442.863 133.449C444.596 127.906 439.449 103.412 438.057 98.965C439.671 101.816 448.978 114.982 450.27 118.131C451.677 122.37 452.512 137.89 453.089 140.49C453.809 143.741 446.142 154.434 445.966 157.021C445.79 159.608 438.999 165.302 439.095 163.899L439.375 159.775C435.941 148.639 432.142 148.681 430.642 150.112C430.633 150.121 430.624 150.13 430.615 150.139Z",
    stroke: "#171717",
    strokeWidth: 0.375796
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M430.166 153.604C431.819 151.199 434.112 151.224 435.051 151.537C436.053 151.6 438.17 152.927 438.621 157.738C438.872 158.489 439.523 160.18 440.124 160.932C440.876 161.871 437.682 164.502 435.051 164.917C434.221 165.048 437.019 162.242 436.178 162.662C435.427 163.038 432.233 165.629 432.233 164.502C432.233 163.6 434.299 161.535 434.675 160.408C433.736 161.31 431.857 163.75 430.166 163.938C427.535 163.938 428.099 162.811 429.79 162.059C431.143 161.458 432.358 158.489 432.984 157.738L430.542 158.716C430.542 159.28 429.79 160.556 429.414 160.932C429.038 161.308 427.535 161.496 427.535 160.932C427.535 160.368 428.099 156.61 430.166 153.604Z",
    fill: "#DFDFDF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M430.542 158.716C430.542 159.28 429.79 160.556 429.414 160.932C429.038 161.308 427.535 161.496 427.535 160.932C427.535 160.368 428.099 156.61 430.166 153.604C431.819 151.199 434.112 151.224 435.051 151.537C436.053 151.6 438.17 152.927 438.621 157.738C438.872 158.489 439.523 160.18 440.124 160.932C440.876 161.871 437.682 164.502 435.051 164.917C434.221 165.048 437.019 162.242 436.178 162.662C435.427 163.038 432.233 165.629 432.233 164.502C432.233 163.6 434.299 161.535 434.675 160.408C433.736 161.31 431.857 163.75 430.166 163.938C427.535 163.938 428.099 162.811 429.79 162.059C431.143 161.458 432.358 158.489 432.984 157.738L430.542 158.716ZM430.542 158.716C430.542 158.153 431.481 156.798 432.608 156.422",
    stroke: "#BEBEBE",
    strokeWidth: 0.375796
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M424.875 58.3146C424.274 55.9095 420.866 56.1851 419.238 56.6235C418.361 56.1225 415.931 55.2331 413.225 55.6841C409.843 56.2478 409.092 59.442 408.528 61.1331C407.964 62.8242 408.528 64.7032 407.4 67.1458C406.499 69.1 404.144 70.0896 403.079 70.3401C399.509 69.4006 402.139 75.2255 402.515 76.5407C402.816 77.593 404.269 77.856 404.958 77.856L407.4 81.4902C407.651 82.555 412.654 87.2399 417.013 87.6909C422.462 88.2546 422.092 85.5533 422.462 84.8724C423.243 83.4334 424.028 82.4297 424.529 81.866C424.905 78.9849 425.1 77.2813 426.002 75.4775C427.13 73.2227 426.566 69.2142 426.002 67.9616C425.752 67.711 425.852 65.6051 426.002 64.7032C426.19 63.5758 425.627 61.321 424.875 58.3146Z",
    fill: "#EAEAEA",
    fillOpacity: 0.8
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M415.134 81.4905C416.261 80.9895 418.629 80.0625 419.08 80.3632C419.643 80.7389 419.831 80.9269 420.207 80.9269C420.583 80.9269 420.771 80.3632 421.147 80.3632C421.522 80.3632 422.274 80.739 422.462 80.9269M417.952 82.2421C418.391 82.6179 419.455 83.2568 420.207 82.8058C420.959 82.3549 421.147 82.1169 421.147 82.0542",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M424.905 65.7621C423.84 65.5742 421.485 65.7621 420.583 68.0169C419.681 70.2717 420.959 74.9065 421.898 76.0965",
    stroke: "black",
    strokeWidth: 0.375796
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M416.261 70.4046C415.572 69.4651 413.142 68.1498 408.933 70.4046M420.77 70.4046C421.021 69.1519 422.123 67.0224 424.528 68.5256",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.503,
    cy: 70.0286,
    r: 0.93949,
    fill: "#0B0F21"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.273,
    cy: 69.2771,
    r: 0.93949,
    fill: "#0B0F21"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3713_16728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.898 76.0964C421.835 76.7227 421.71 77.0359 420.958 77.2238C420.229 77.4061 420.019 77.2238 419.455 76.9809C418.891 76.7379 417.388 77.7324 417.2 76.9809M416.825 68.1496C416.261 67.5233 414.607 66.3082 412.503 66.4586C410.398 66.6089 408.87 68.0244 408.369 68.7133",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M401.639 105.228C400.073 98.8646 392.656 97.2737 389.143 97.2737C385.379 99.3248 377.188 106.999 374.538 121.287C371.226 139.147 376.195 149.053 377.55 156.107C378.905 163.16 386.884 172.466 385.228 183.122C384.174 185.973 395.165 183.422 397.122 183.122C399.08 182.821 405.554 175.918 409.017 170.064C412.48 164.211 421.061 159.558 423.019 158.658C424.585 157.938 420.961 153.255 418.954 151.004C418.201 148.652 416.575 143.5 416.093 141.698C415.491 139.447 409.318 126.24 408.113 123.839C406.909 121.437 403.596 113.183 401.639 105.228Z",
    fill: "#292929"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M385.228 183.122C384.174 185.973 395.165 183.422 397.122 183.122C399.08 182.821 405.554 175.918 409.017 170.064C412.48 164.211 421.061 159.558 423.019 158.658C424.585 157.938 420.961 153.255 418.954 151.004C418.201 148.652 416.575 143.5 416.093 141.698C415.491 139.447 409.318 126.24 408.113 123.839C406.909 121.437 403.596 113.183 401.639 105.228C400.073 98.8646 392.656 97.2737 389.143 97.2737C385.379 99.3248 377.188 106.999 374.538 121.287C371.226 139.147 376.195 149.053 377.55 156.107C378.905 163.16 386.884 172.466 385.228 183.122ZM385.228 183.122C386.282 180.27 391.1 179.219 392.756 177.118C394.412 175.017 396.219 172.466 397.122 170.064",
    stroke: "#171717",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M420.025 171.104C419.667 170.14 416.799 166.888 415.41 165.382C414.099 164.66 410.894 168.494 409.455 170.502C408.264 173.272 410.546 176.474 411.837 177.729C410.646 181.222 412.928 181.694 414.219 181.493C415.171 182.818 416.501 182.447 417.047 182.096C419.429 183.902 420.322 182.447 420.471 181.493C421.166 182.146 422.704 183.059 423.3 181.493C424.044 179.536 420.471 172.309 420.025 171.104Z",
    fill: "#DFDFDF",
    stroke: "#BEBEBE",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  }))), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 67,
    width: 107,
    height: 26,
    fill: "#C4C4C4"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.5,
    cy: 74.5,
    rx: 33.5,
    ry: 10.5,
    fill: "#A8A8A8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281,
    cy: 85.5,
    rx: 19,
    ry: 5.5,
    fill: "#A8A8A8"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.366,
    cy: 57.3807,
    rx: 11.5197,
    ry: 5.19514,
    fill: "#C4C4C4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M272.698 71.2344C269.913 69.0509 266.374 61.9735 265.771 57.5312C266.449 52.7878 268.03 53.3149 269.009 50.755C269.792 48.707 267.177 46.4382 265.771 45.5598H288.811C287.004 46.2123 285.031 48.1649 285.573 50.755C286.115 53.345 288.811 54.2937 288.811 57.5312C288.269 63.4944 284.118 69.1513 282.11 71.2344C280.077 71.8367 275.074 73.0967 272.698 71.2344Z",
    fill: "#707070"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.366,
    cy: 71.1592,
    rx: 4.74339,
    ry: 1.50584,
    fill: "#707070"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.29,
    cy: 45.1835,
    rx: 11.595,
    ry: 2.18347,
    fill: "#3A3A3A"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.325,
    cy: 64.2322,
    r: 6.32452,
    fill: "#6C6C6C"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.607,
    cy: 66.6418,
    r: 6.02336,
    fill: "#676767"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.189,
    cy: 67.1689,
    r: 5.49631,
    fill: "#BFBFBF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.619,
    cy: 65.1357,
    r: 9.48679,
    fill: "#A2A2A2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.479,
    cy: 65.1357,
    r: 9.48679,
    fill: "#CACACA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M277.218 70.5144C277.304 70.9527 277.447 71.5656 277.642 72.2783M280.133 78.4448C281.727 81.0493 283.289 81.5629 283.871 81.4942M280.133 78.4448C280.674 79.6452 281.738 82.3503 281.661 83.5676M280.133 78.4448C280.19 78.6372 279.867 79.0271 278.113 79.0473M280.133 78.4448C279.773 77.8563 279.442 77.2085 279.143 76.5401M279.143 76.5401C279.733 76.9927 281.132 77.8954 282.009 77.8853M279.143 76.5401C278.723 75.6036 278.365 74.6269 278.071 73.717M278.071 73.717C279.179 73.8056 281.57 73.8836 282.268 73.4866M278.071 73.717C277.908 73.2106 277.765 72.7249 277.642 72.2783M277.642 72.2783C277.453 73.1975 276.626 75.1693 274.837 75.703",
    stroke: "#505050",
    strokeWidth: 0.292857,
    strokeLinecap: "round"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.734,
    cy: 85.7296,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 280.734 85.7296)",
    fill: "#707070"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.086,
    cy: 77.7373,
    rx: 2.93639,
    ry: 3.01168,
    transform: "rotate(-16.6063 284.086 77.7373)",
    fill: "#616161"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.949,
    cy: 71.5551,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 282.949 71.5551)",
    fill: "#505050"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.73,
    cy: 77.0917,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 290.73 77.0917)",
    fill: "#505050"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.202,
    cy: 81.3117,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 269.202 81.3117)",
    fill: "#505050"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.134,
    cy: 82.2335,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 286.134 82.2335)",
    fill: "#707070"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.094,
    cy: 74.5779,
    rx: 3.16226,
    ry: 3.23755,
    transform: "rotate(-16.6063 288.094 74.5779)",
    fill: "#616161"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.742,
    cy: 70.7399,
    rx: 4.59281,
    ry: 4.6681,
    transform: "rotate(-16.6063 291.742 70.7399)",
    fill: "#707070"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.687,
    cy: 76.6586,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 272.687 76.6586)",
    fill: "#505050"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.063,
    cy: 76.7017,
    rx: 2.93639,
    ry: 3.01168,
    transform: "rotate(-16.6063 268.063 76.7017)",
    fill: "#707070"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.643,
    cy: 81.0408,
    rx: 4.14106,
    ry: 4.21635,
    transform: "rotate(-16.6063 275.643 81.0408)",
    fill: "#707070"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.832,
    cy: 75.6015,
    r: 5.6469,
    fill: "#6C6C6C"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M354.39 467.081L381.674 459.032C382.518 458.783 383.421 459.114 383.908 459.852L397.163 479.929C394.746 477.186 391.255 475.364 388.674 474.454C385.239 473.241 382.972 473.527 381.463 476.535C381.457 476.507 381.452 476.479 381.447 476.451C381.026 474.177 380.566 471.693 376.7 470.818C373.078 469.999 370.911 471.631 368.739 473.267C368.266 473.623 367.793 473.979 367.305 474.31C366.57 472.036 365.367 470.855 363.83 470.313C361.235 469.397 358.89 469.379 356.794 470.293C356.287 469.092 355.465 467.984 354.39 467.081Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M360.523 469.869L348.418 443.912C348.044 443.109 347.199 442.646 346.328 442.766L322.647 446.05C326.284 446.059 329.949 447.491 332.335 448.838C335.511 450.632 336.801 452.535 335.569 455.669C335.593 455.654 335.618 455.64 335.642 455.625C337.608 454.437 339.757 453.139 342.967 455.481C345.975 457.677 346.2 460.396 346.425 463.122C346.474 463.715 346.523 464.309 346.601 464.897C348.776 463.946 350.45 464.073 351.87 464.875C354.269 466.23 355.836 467.99 356.547 470.18C357.774 469.768 359.141 469.655 360.523 469.869Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M361.262 459.948C363.193 460.826 365.531 460.147 367.449 458.404C367.437 459.805 367.116 461.317 366.457 462.794C366.052 463.702 365.551 464.523 364.986 465.238L354.237 479.558C353.196 480.944 351.028 479.958 351.367 478.252L354.842 460.802C354.993 459.849 355.279 458.871 355.709 457.907C356.368 456.431 357.277 455.186 358.309 454.248C358.286 456.853 359.332 459.071 361.262 459.948Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M947.749 103.551C943.52 105.274 933.762 111.499 932 113V120H1011V107.5L1005.71 105.901C999.055 103.943 988.872 99.2428 987.305 96.1096C985.739 92.9765 964.394 94.3472 964.003 95.3263C963.689 96.1096 960.739 98.2637 959.303 99.2428C957.214 99.9608 951.979 101.828 947.749 103.551Z",
    fill: "#6D6D6D"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M988.48 53.6162C991.744 55.9008 998.232 61.9582 998.076 67.9112C997.88 75.3525 997.88 73.9817 996.117 77.3107C994.355 80.6397 992.788 83.7729 992.788 85.7311C992.788 87.6893 990.634 91.9974 987.893 91.9974C985.151 91.9974 986.522 95.5222 984.564 96.3055C983.99 96.5348 982.293 96.9991 980.06 97.3937C979.704 97.4796 979.363 97.5349 979.035 97.5635C975.075 98.175 969.876 98.4683 966.156 97.0378C964.81 96.5198 963.657 95.7757 962.827 94.7389C958.178 88.9276 957.937 88.0985 956.605 83.532L956.561 83.3812C955.19 78.6815 954.603 77.7024 954.799 75.1567C954.211 74.5039 953.036 72.8851 953.036 71.6319C953.036 70.0653 953.624 69.0862 953.624 68.4987C953.624 67.9112 950.686 67.3238 951.861 66.1488C953.036 64.9739 954.211 64.3864 954.799 62.0366C955.386 59.6867 955.974 56.7494 955.778 55.1828C956.822 54.3995 959.107 53.1462 959.89 54.3995C960.869 55.9661 987.501 56.1619 988.48 53.6162Z",
    fill: "#5A5A5A"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M966.156 97.0378C964.81 96.5198 963.657 95.7757 962.827 94.7389C958.128 88.8643 957.932 88.081 956.561 83.3812C955.19 78.6815 954.603 77.7024 954.799 75.1567C954.211 74.5039 953.036 72.8851 953.036 71.6319C953.036 70.0653 953.624 69.0862 953.624 68.4987C953.624 67.9112 950.686 67.3238 951.861 66.1488C953.036 64.9739 954.211 64.3864 954.799 62.0366C955.386 59.6867 955.974 56.7494 955.778 55.1828C956.822 54.3995 959.107 53.1462 959.89 54.3995C960.869 55.9661 987.501 56.1619 988.48 53.6162C991.744 55.9008 998.232 61.9582 998.076 67.9112C997.88 75.3525 997.88 73.9817 996.117 77.3107C994.355 80.6397 992.788 83.7729 992.788 85.7311C992.788 87.6893 990.634 91.9974 987.893 91.9974C985.151 91.9974 986.522 95.5222 984.564 96.3055C983.99 96.5348 982.293 96.9991 980.06 97.3938M966.156 97.0378C967.704 97.0935 970.711 96.6122 973.611 94.7389M966.156 97.0378C970.207 98.5955 976.012 98.1091 980.06 97.3938M973.611 94.7389C974.259 95.9866 976.457 98.2643 980.06 97.3938M973.611 94.7389C974.699 94.0361 975.772 93.1373 976.746 91.9974M963.807 85.7311C965.7 88.7337 971.091 93.9948 977.514 91.0183C977.266 91.3629 977.01 91.689 976.746 91.9974M976.746 91.9974C978.569 92.7154 982.997 92.4674 986.13 85.7311",
    stroke: "#3F3F3F",
    strokeWidth: 0.78329,
    strokeLinecap: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M976.732 45.1772C968.272 43.7673 962.11 51.1171 960.087 54.9683C956.17 61.6263 958.716 70.2425 960.087 75.9213C961.458 81.6002 964.199 90.4122 975.949 90.4122C987.698 90.4122 987.502 80.8169 991.418 70.6341C995.335 60.4513 991.418 54.9683 989.069 49.6811C987.189 45.4513 980.061 44.9161 976.732 45.1772Z",
    fill: "#626262"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M976.732 47.3499C975.471 52.0496 973.25 62.7807 974.449 68.107M974.449 49.6811C970.684 50.079 962.54 52.4413 960.087 58.7076M976.732 49.6811C980.518 50.2748 988.575 52.3238 990.507 55.7702M960.087 54.9683C962.11 51.1171 968.272 43.7673 976.732 45.1772C980.061 44.9161 987.189 45.4513 989.069 49.6811C991.418 54.9683 995.335 60.4513 991.418 70.6341C987.502 80.8169 987.698 90.4122 975.949 90.4122C964.199 90.4122 961.458 81.6002 960.087 75.9213C958.716 70.2425 956.17 61.6263 960.087 54.9683Z",
    stroke: "#393939",
    strokeWidth: 0.78329,
    strokeLinecap: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M983.666 79.2614C984.026 78.2721 985.187 76.3302 986.953 76.4759C988.001 76.5624 988.453 76.5997 988.609 76.6125C988.609 76.6125 988.609 76.6125 988.609 76.6125C988.684 76.6187 988.716 76.6214 988.609 76.6125C988.901 77.5629 988.825 79.7148 986.186 80.7197C983.547 81.7246 983.407 80.1662 983.666 79.2614Z",
    fill: "#636363",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M980.005 79.6708C980.798 78.9782 982.752 77.838 984.228 78.8186C985.104 79.4002 985.482 79.6512 985.612 79.7378C985.612 79.7378 985.612 79.7378 985.612 79.7378C985.675 79.7794 985.702 79.7973 985.612 79.7378C985.409 80.7111 984.304 82.559 981.507 82.1644C978.711 81.7699 979.341 80.3376 980.005 79.6708Z",
    fill: "#636363",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M975.201 80.162C976.115 79.6398 978.256 78.9087 979.51 80.162C980.253 80.9053 980.574 81.2261 980.685 81.3369C980.685 81.3369 980.685 81.3369 980.685 81.3369C980.738 81.39 980.76 81.4129 980.685 81.3369C980.293 82.2507 978.844 83.8434 976.181 82.9035C973.517 81.9635 974.418 80.6842 975.201 80.162Z",
    fill: "#636363",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M971.306 79.4623C972.247 79.1058 974.38 78.7364 975.375 80.1107C975.965 80.9259 976.219 81.2777 976.307 81.3992C976.307 81.3992 976.307 81.3992 976.307 81.3992C976.349 81.4575 976.368 81.4825 976.307 81.3992C975.8 82.2049 974.191 83.4937 971.817 82.2035C969.443 80.9134 970.487 79.8385 971.306 79.4623Z",
    fill: "#636363",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M967.368 79.3788C968.282 78.8566 970.423 78.1255 971.677 79.3788C972.42 80.1221 972.741 80.4429 972.851 80.5537C972.851 80.5537 972.851 80.5537 972.851 80.5537C972.905 80.6068 972.927 80.6297 972.851 80.5537C972.46 81.4675 971.011 83.0602 968.348 82.1203C965.684 81.1803 966.585 79.9009 967.368 79.3788Z",
    fill: "#636363",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M961.606 80.4131C960.65 79.7907 960.623 78.0611 960.729 77.2741C960.717 77.1587 960.798 76.9452 961.219 77.0152C961.567 77.0507 962.051 77.1531 962.551 77.3475C963.902 77.1751 966.891 77.4928 968.042 80.1424C967.288 80.9553 965.272 82.1519 963.239 80.4349C962.67 80.6475 962.07 80.715 961.606 80.4131Z",
    fill: "#636363"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M962.551 77.3475C962.051 77.1531 961.567 77.0507 961.219 77.0152C960.798 76.9452 960.717 77.1587 960.729 77.2741C960.623 78.0611 960.65 79.7907 961.606 80.4131C962.07 80.715 962.67 80.6475 963.239 80.4349M962.551 77.3475C963.478 77.7078 964.461 78.3841 964.745 79.5363C964.411 79.8203 963.842 80.2093 963.239 80.4349M962.551 77.3475C963.902 77.1751 966.891 77.4928 968.042 80.1424C967.288 80.9553 965.272 82.1519 963.239 80.4349",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M983.287 81.8914C983.623 81.0234 984.707 79.3193 986.358 79.4472C987.337 79.523 987.76 79.5558 987.906 79.5671C987.906 79.5671 987.906 79.5671 987.906 79.5671C987.976 79.5725 988.006 79.5748 987.906 79.5671C988.179 80.401 988.108 82.2893 985.641 83.1711C983.175 84.0528 983.044 82.6854 983.287 81.8914Z",
    fill: "#5E5E5E",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M979.865 82.251C980.605 81.6432 982.432 80.6427 983.812 81.5031C984.63 82.0135 984.983 82.2337 985.105 82.3098C985.105 82.3098 985.105 82.3098 985.105 82.3098C985.164 82.3463 985.189 82.3619 985.105 82.3098C984.915 83.1638 983.882 84.7853 981.269 84.4391C978.655 84.0929 979.244 82.8361 979.865 82.251Z",
    fill: "#5E5E5E",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M975.376 82.6819C976.23 82.2237 978.231 81.5822 979.402 82.6819C980.097 83.3342 980.397 83.6157 980.5 83.7129C980.5 83.7129 980.5 83.7129 980.5 83.7129C980.55 83.7595 980.571 83.7796 980.5 83.7129C980.134 84.5148 978.78 85.9124 976.291 85.0876C973.802 84.2628 974.643 83.1401 975.376 82.6819Z",
    fill: "#5E5E5E",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M971.734 82.068C972.615 81.7552 974.608 81.431 975.538 82.637C976.089 83.3523 976.327 83.661 976.409 83.7676C976.409 83.7676 976.409 83.7676 976.409 83.7676C976.449 83.8187 976.466 83.8407 976.409 83.7676C975.935 84.4746 974.431 85.6055 972.213 84.4734C969.994 83.3413 970.969 82.3981 971.734 82.068Z",
    fill: "#5E5E5E",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M968.054 81.9947C968.908 81.5364 970.909 80.8949 972.081 81.9947C972.775 82.647 973.075 82.9285 973.179 83.0257C973.179 83.0257 973.179 83.0257 973.179 83.0257C973.228 83.0723 973.25 83.0923 973.179 83.0257C972.813 83.8276 971.458 85.2251 968.969 84.4003C966.48 83.5755 967.322 82.4529 968.054 81.9947Z",
    fill: "#5E5E5E",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M962.668 82.9023C961.775 82.3562 961.749 80.8385 961.848 80.1479C961.837 80.0466 961.912 79.8593 962.306 79.9207C962.631 79.9518 963.083 80.0417 963.551 80.2123C964.814 80.0611 967.607 80.3398 968.683 82.6648C967.979 83.3782 966.095 84.4282 964.194 82.9215C963.662 83.108 963.101 83.1673 962.668 82.9023Z",
    fill: "#5E5E5E"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M963.551 80.2123C963.083 80.0417 962.631 79.9518 962.306 79.9207C961.912 79.8593 961.837 80.0466 961.848 80.1479C961.749 80.8385 961.775 82.3562 962.668 82.9023C963.101 83.1673 963.662 83.108 964.194 82.9215M963.551 80.2123C964.417 80.5285 965.337 81.1219 965.602 82.1329C965.29 82.3822 964.758 82.7235 964.194 82.9215M963.551 80.2123C964.814 80.0611 967.607 80.3398 968.683 82.6648C967.979 83.3782 966.095 84.4282 964.194 82.9215",
    stroke: "#444444",
    strokeWidth: 0.78329
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M983.599 74.2105C984.095 75.1385 985.521 76.8954 987.248 76.4995C988.273 76.2647 988.715 76.1634 988.868 76.1284C988.868 76.1284 988.868 76.1284 988.868 76.1284C988.941 76.1116 988.973 76.1044 988.868 76.1284C989.022 75.1461 988.64 73.0269 985.885 72.4082C983.129 71.7895 983.213 73.352 983.599 74.2105Z",
    fill: "#646464",
    stroke: "#424242",
    strokeWidth: 0.78329
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M979.614 73.5846C980.406 74.2772 982.36 75.4174 983.836 74.4368C984.712 73.8552 985.09 73.6042 985.221 73.5175C985.221 73.5175 985.221 73.5175 985.221 73.5175C985.283 73.476 985.31 73.4581 985.221 73.5175C985.017 72.5443 983.912 70.6964 981.116 71.0909C978.319 71.4854 978.949 72.9177 979.614 73.5846Z",
    fill: "#646464",
    stroke: "#424242",
    strokeWidth: 0.78329
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M975.176 73.6448C976.08 74.1945 978.198 74.9641 979.438 73.6448C980.173 72.8623 980.49 72.5246 980.6 72.408C980.6 72.408 980.6 72.408 980.6 72.408C980.652 72.3521 980.675 72.3281 980.6 72.408C980.212 71.446 978.779 69.7695 976.145 70.7589C973.51 71.7484 974.401 73.0951 975.176 73.6448Z",
    fill: "#646464",
    stroke: "#424242",
    strokeWidth: 0.78329
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M972.072 74.1548C973.014 74.5114 975.146 74.8808 976.141 73.5064C976.731 72.6913 976.986 72.3394 977.074 72.218C977.074 72.218 977.074 72.218 977.074 72.218C977.116 72.1597 977.134 72.1347 977.074 72.218C976.566 71.4123 974.957 70.1235 972.584 71.4137C970.21 72.7038 971.254 73.7787 972.072 74.1548Z",
    fill: "#646464",
    stroke: "#424242",
    strokeWidth: 0.78329
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M967.735 74.0367C968.639 74.5864 970.757 75.356 971.996 74.0367C972.732 73.2542 973.049 72.9165 973.158 72.7999C973.158 72.7999 973.158 72.7999 973.158 72.7999C973.211 72.744 973.234 72.7199 973.158 72.7999C972.771 71.8379 971.338 70.1613 968.703 71.1508C966.069 72.1402 966.96 73.487 967.735 74.0367Z",
    fill: "#646464",
    stroke: "#424242",
    strokeWidth: 0.78329
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M961.605 72.8468C960.648 73.4638 960.612 75.1653 960.714 75.9389C960.701 76.0525 960.78 76.2621 961.201 76.1911C961.549 76.1545 962.032 76.0513 962.533 75.8576C963.881 76.0203 967.932 75.4589 969.094 72.8467C968.346 72.0509 965.274 71.1179 963.235 72.8171C962.668 72.6109 962.069 72.5474 961.605 72.8468Z",
    fill: "#646464"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M962.533 75.8576C962.032 76.0513 961.549 76.1545 961.201 76.1911C960.78 76.2621 960.701 76.0525 960.714 75.9389C960.612 75.1653 960.648 73.4638 961.605 72.8468C962.069 72.5474 962.668 72.6109 963.235 72.8171M962.533 75.8576C963.46 75.4985 964.446 74.8283 964.735 73.6935C964.403 73.4158 963.837 73.036 963.235 72.8171M962.533 75.8576C963.881 76.0203 967.932 75.4589 969.094 72.8467C968.346 72.0509 965.274 71.1179 963.235 72.8171",
    stroke: "#424242",
    strokeWidth: 0.78329
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M983.599 72.2523C984.095 73.1802 985.521 74.9371 987.248 74.5413C988.273 74.3065 988.715 74.2051 988.868 74.1701C988.868 74.1701 988.868 74.1701 988.868 74.1702C988.941 74.1534 988.973 74.1461 988.868 74.1701C989.022 73.1879 988.64 71.0687 985.885 70.45C983.129 69.8313 983.213 71.3937 983.599 72.2523Z",
    fill: "#646464",
    stroke: "#484848",
    strokeWidth: 0.78329
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M979.614 71.6263C980.406 72.319 982.36 73.4591 983.836 72.4786C984.712 71.897 985.09 71.6459 985.221 71.5593C985.221 71.5593 985.221 71.5593 985.221 71.5593C985.283 71.5177 985.31 71.4998 985.221 71.5593C985.017 70.586 983.912 68.7382 981.116 69.1327C978.319 69.5272 978.949 70.9595 979.614 71.6263Z",
    fill: "#646464",
    stroke: "#484848",
    strokeWidth: 0.78329
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M975.176 71.6866C976.08 72.2363 978.198 73.0059 979.438 71.6866C980.173 70.9041 980.49 70.5664 980.6 70.4498C980.6 70.4498 980.6 70.4498 980.6 70.4498C980.652 70.3939 980.675 70.3698 980.6 70.4498C980.212 69.4878 978.779 67.8112 976.145 68.8007C973.51 69.7901 974.401 71.1369 975.176 71.6866Z",
    fill: "#646464",
    stroke: "#484848",
    strokeWidth: 0.78329
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M972.072 72.1966C973.014 72.5531 975.146 72.9226 976.141 71.5482C976.731 70.733 976.986 70.3812 977.074 70.2597C977.074 70.2597 977.074 70.2597 977.074 70.2597C977.116 70.2015 977.134 70.1764 977.074 70.2597C976.566 69.4541 974.957 68.1653 972.584 69.4554C970.21 70.7455 971.254 71.8204 972.072 72.1966Z",
    fill: "#646464",
    stroke: "#484848",
    strokeWidth: 0.78329
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M967.735 72.0784C968.639 72.6281 970.757 73.3977 971.996 72.0784C972.732 71.2959 973.049 70.9582 973.158 70.8416C973.158 70.8416 973.158 70.8416 973.158 70.8416C973.211 70.7857 973.234 70.7616 973.158 70.8416C972.771 69.8796 971.338 68.2031 968.703 69.1925C966.069 70.182 966.96 71.5287 967.735 72.0784Z",
    fill: "#646464",
    stroke: "#484848",
    strokeWidth: 0.78329
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M961.605 70.8883C960.648 71.5053 960.612 73.2068 960.714 73.9804C960.701 74.094 960.78 74.3036 961.201 74.2326C961.549 74.196 962.032 74.0928 962.533 73.8991C963.881 74.0618 967.932 73.5004 969.094 70.8882C968.346 70.0924 965.274 69.1594 963.235 70.8586C962.668 70.6524 962.069 70.5889 961.605 70.8883Z",
    fill: "#646464"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M962.533 73.8991C962.032 74.0928 961.549 74.196 961.201 74.2326C960.78 74.3036 960.701 74.094 960.714 73.9804C960.612 73.2068 960.648 71.5053 961.605 70.8883C962.069 70.5889 962.668 70.6524 963.235 70.8586M962.533 73.8991C963.46 73.54 964.446 72.8698 964.735 71.735C964.403 71.4573 963.837 71.0775 963.235 70.8586M962.533 73.8991C963.881 74.0618 967.932 73.5004 969.094 70.8882C968.346 70.0924 965.274 69.1594 963.235 70.8586",
    stroke: "#484848",
    strokeWidth: 0.78329
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M610.045 46.2012C615.337 42.2627 631.268 31.9797 633.475 26.389C634.062 27.5877 630.433 37.4049 622.737 40.5825C626.966 41.6868 636.286 44.0544 639.73 44.6896C644.035 45.4835 651.595 46.03 654.022 42.8797C656.449 39.7295 659.794 34.0172 653.953 27.9986C656.046 27.9889 659.987 30.4122 659.009 40.1827C660.524 40.9121 664.809 40.5154 666.878 32.2407C668.362 26.3045 667.762 22.2381 664.478 15.9751C659.986 7.40872 666.094 13.4099 666.799 15.0343C667.504 16.6587 672.422 24.3093 671.058 31.0588C670.719 32.7371 670.458 33.8445 670.259 34.5458C672.73 32.4984 677.211 28.4527 679.17 25.4408C678.22 29.3593 674.74 37.9012 668.428 40.7206L664.61 44.5748C661.601 47.6115 651.614 50.2153 643.593 50.3686C635.572 50.5218 630.928 47.336 626.158 46.7767C621.389 46.2174 615.331 48.0574 612.553 50.8605C609.776 53.6635 611.441 46.1948 610.045 46.2012Z",
    fill: "#9B9B9B",
    stroke: "#727272",
    strokeWidth: 0.567239
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M659.003 26.4058C656.429 32.9283 645.818 41.348 640.834 44.7426C642.698 45.4781 646.069 45.2998 647.521 45.1187C657.986 35.2115 659.536 28.5154 659.003 26.4058Z",
    fill: "#9B9B9B",
    stroke: "#727272",
    strokeWidth: 0.567239
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M593.955 45.0369C588.663 41.0984 572.732 30.8154 570.525 25.2247C569.938 26.4234 573.567 36.2406 581.263 39.4182C577.034 40.5225 567.714 42.8901 564.27 43.5253C559.965 44.3192 552.405 44.8657 549.978 41.7154C547.551 38.5652 544.206 32.8529 550.047 26.8343C547.954 26.8246 544.013 29.2479 544.991 39.0184C543.476 39.7478 539.191 39.3511 537.122 31.0763C535.638 25.1402 536.238 21.0738 539.522 14.8108C544.014 6.24442 537.906 12.2456 537.201 13.87C536.496 15.4944 531.578 23.145 532.942 29.8945C533.281 31.5728 533.542 32.6802 533.741 33.3815C531.27 31.3341 526.789 27.2884 524.83 24.2765C525.78 28.195 529.26 36.7369 535.572 39.5563L539.39 43.4105C542.399 46.4472 552.386 49.051 560.407 49.2043C568.428 49.3575 573.072 46.1717 577.842 45.6124C582.611 45.0531 588.669 46.8931 591.447 49.6962C594.224 52.4992 592.559 45.0305 593.955 45.0369Z",
    fill: "#9B9B9B",
    stroke: "#727272",
    strokeWidth: 0.567239
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M544.997 25.2415C547.571 31.764 558.182 40.1837 563.166 43.5783C561.302 44.3138 557.931 44.1355 556.479 43.9544C546.014 34.0472 544.464 27.3511 544.997 25.2415Z",
    fill: "#9B9B9B",
    stroke: "#727272",
    strokeWidth: 0.567239
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M599.057 48.0098C598.136 48.9306 596.81 45.8724 596.262 44.2282C589.883 45.7409 588.014 49.243 587.877 50.8049C588.425 50.8049 589.702 50.8871 590.425 51.216C591.149 51.5448 591.275 54.5865 591.247 56.0663C591.165 55.7374 590.179 55.573 589.521 55.573C588.863 55.573 586.89 57.8749 586.644 61.1632C586.397 64.4516 587.877 67.7399 588.617 68.3976C589.209 68.9237 590.069 68.6168 590.425 68.3976C590.82 68.9237 592.179 78.5914 592.809 83.3595C593.138 84.6091 595.851 85.6888 597.166 86.0724C596.673 88.7853 598.399 92.8957 599.057 95.4442C599.715 97.9926 601.688 98.1571 602.181 98.1571C602.674 98.1571 602.756 95.362 602.921 95.4442C603.085 95.5264 602.181 96.3485 604.401 97.9104C606.176 99.16 608.593 90.5391 609.58 86.0724C611.092 85.4805 612.512 83.798 613.033 83.0307C612.769 81.3207 614.512 72.1243 615.417 67.7399C615.663 67.9317 616.272 68.266 616.732 68.0687C617.307 67.8221 618.047 63.9583 618.047 61.1632C618.047 58.3681 615.006 55.573 614.512 55.2442C614.019 54.9154 614.595 51.1338 615.828 50.8049C616.814 50.5419 617.006 50.6953 616.979 50.8049C618.129 48.6675 609.58 43.4062 609.909 44.2282C610.172 44.8859 608.155 46.4753 607.114 47.1878C604.812 48.6675 604.154 46.6945 602.839 45.708C601.523 44.7215 600.208 46.8589 599.057 48.0098Z",
    fill: "#E9E9E9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M598.579 87.4516C598.71 90.0165 600.826 93.2884 601.867 94.6037C602.853 95.9954 601.867 88.3558 602.525 87.4516C603.182 86.5473 602.853 88.4381 603.1 88.9313C603.347 89.4246 603.347 88.1914 603.758 87.4516C604.169 86.7117 603.347 94.6037 604.169 94.6037C604.991 94.6037 607.128 88.4381 607.457 85.8896C607.786 83.3411 606.388 82.1902 605.813 80.9571C605.237 79.7239 605.237 82.4368 604.169 82.8479C603.1 83.2589 604.004 82.0258 604.169 80.9571C604.333 79.8884 602.689 80.8749 601.867 80.2994C601.045 79.724 601.867 82.0258 600.88 82.8479C599.894 83.67 600.14 81.697 599.894 80.2994C599.647 78.9019 598.414 84.2454 598.579 87.4516Z",
    fill: "#1D1D1D",
    stroke: "black",
    strokeWidth: 0.18908
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M592.069 62.3964C592.069 65.2567 591.411 68.0688 589.849 67.2467C588.487 67.2467 587.383 64.9279 587.383 62.0675C588.123 58.9436 588.651 57.4639 590.013 57.4639C591.164 58.286 592.644 59.0258 592.069 62.3964Z",
    fill: "#1D1D1D"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M617.307 61.0809C617.061 63.7116 618.211 64.5337 615.91 66.8355C613.608 67.5754 613.073 64.8216 612.704 61.9852C612.334 59.1488 612.128 57.6282 614.163 56.549C615.17 55.7374 616.567 59.2723 617.307 61.0809Z",
    fill: "#1D1D1D"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M598.646 64.2047C598.4 65.0542 598.054 67.0656 598.646 68.3152C599.386 69.8771 600.044 70.7814 600.044 71.3569C600.044 71.9324 599.715 78.4268 600.373 77.7692C601.03 77.1115 601.606 75.2207 601.935 75.7962C602.263 76.3716 602.674 77.1115 602.757 76.4538C602.839 75.7962 603.085 72.3434 602.757 71.3569C602.428 70.3704 602.263 69.1373 602.757 67.4931C603.25 65.8489 603.661 63.3005 603.003 62.2317C602.346 61.163 603.743 58.2857 603.496 57.7925C603.359 58.3131 603.168 59.7162 603.496 61.163C603.908 62.9716 604.154 64.9446 603.825 65.6845C603.496 66.4244 602.757 68.5618 603.003 69.6305C603.25 70.6992 603.496 74.4808 603.496 75.1385C603.496 75.7962 603.332 76.2072 603.825 75.7962C604.319 75.3851 604.483 74.9741 604.647 75.3851C604.812 75.7962 605.058 76.7004 605.141 76.9471C605.223 77.1937 605.881 77.1115 605.963 76.125C606.045 75.1385 605.881 73.0833 606.292 71.6035C606.703 70.1238 607.114 68.8084 607.525 69.2195",
    stroke: "black",
    strokeWidth: 0.567239,
    strokeLinecap: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M609.168 42.7199C609.431 42.2595 610.593 42.9117 611.141 43.2954C612.21 44.0352 614.676 45.7616 615.991 46.7481C618.112 48.3387 617.636 49.7898 617.718 50.6941C617.8 51.5984 616.649 52.1739 616.649 51.1874C616.649 50.2009 610.155 45.1039 609.168 44.3641C608.182 43.6242 608.839 43.2954 609.168 42.7199Z",
    fill: "#B0B0B0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M595.028 42.5555C596.146 42.0293 596.426 43.1583 596.426 43.7886C596.497 44.3641 595.521 44.8573 594.042 45.7616C592.562 46.6659 591.329 48.5567 590.342 49.2144C589.356 49.872 588.698 51.1874 587.629 51.1874C586.561 51.1874 588.863 47.9812 589.356 47.2414C589.849 46.5015 593.631 43.2131 595.028 42.5555Z",
    fill: "#B0B0B0"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 615,
    cy: 59.5,
    rx: 1,
    ry: 1.5,
    fill: "#C4C4C4"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590,
    cy: 60.5,
    rx: 1,
    ry: 1.5,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3713_16728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 727,
    y: 30,
    width: 146,
    height: 152
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 30,
    width: 146,
    height: 152,
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3713_16728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.09 117.152C809.624 115.442 808.443 101.68 808.036 95.0132C797.704 101.68 777.377 115.686 778.721 118.374C780.4 121.733 777.499 140.207 778.721 144.177C779.942 148.147 812.922 119.29 811.09 117.152Z",
    fill: "#A5A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.311 43.2347C787.677 42.6239 768.147 47.7524 765.582 54.5925C762.376 63.1427 763.903 76.4261 763.445 78.1056C762.987 79.7851 760.696 83.6022 762.071 86.1978C763.445 88.7934 764.972 98.565 766.498 99.9392C768.025 101.313 773.369 110.627 773.827 112.764C774.285 114.902 777.95 119.483 779.324 120.093C780.698 120.704 789.706 123.605 794.134 117.345C798.562 111.085 801.615 112.459 806.348 102.687C808.545 98.1531 809.066 95.6255 808.909 94.3123C809.813 94.8808 811.155 94.7218 812.761 92.1524C815.357 87.5719 817.952 87.5719 818.105 82.8388C818.258 78.1056 816.273 75.9681 815.051 75.6627C813.83 75.3573 807.875 79.1744 807.875 81.4646C806.857 73.5251 805.127 57.2187 806.348 55.5086C810.208 50.1054 800.93 43.3688 795.311 43.2347Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.602 76.2535C781.48 75.3985 782.569 73.4543 783.129 72.5891C784.656 71.0623 788.778 71.8257 790 71.5204C791.221 71.215 796.107 74.4213 797.329 75.9481C798.55 77.475 798.55 78.8491 797.481 81.9028C796.412 84.9564 790 84.0403 788.778 83.8876C787.557 83.7349 785.877 80.2233 784.961 79.6125C784.045 79.0018 781.755 77.3223 781.602 76.2535Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.869 75.0321C776.991 72.7113 775.393 72.4365 774.579 72.5891C771.373 71.673 766.639 73.3526 766.181 73.5052C765.723 73.6579 766.334 77.3223 764.96 78.8491C763.586 80.3759 765.113 83.1242 767.403 84.3457C769.693 85.5671 774.579 82.5135 775.648 81.9028C776.716 81.292 776.716 77.933 776.869 75.0321Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.958 74.2483C777.347 77.8618 776.065 85.5468 775.82 87.379C775.515 89.6692 774.294 92.8755 776.126 93.3336C777.958 93.7916 779.179 93.4863 779.637 92.8755C780.095 92.2648 781.47 91.5014 782.386 91.8068C783.302 92.1121 784.676 93.4863 784.676 94.097C784.676 94.7077 786.05 95.0131 786.355 94.555",
    stroke: "#A0A0A0",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.523 93.9142C782.813 91.1049 781.317 91.5015 779.943 92.5702C779.943 93.7917 780.859 93.1508 782.691 93.9142C784.157 94.525 784.523 94.1687 784.523 93.9142Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.35901,
    transform: "matrix(-1 0 0 1 789.714 76.9967)",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.67951,
    transform: "matrix(-1 0 0 1 789.867 77.1495)",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 789.867 77.1495)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 789.867 77.1495)",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.05365,
    transform: "matrix(-1 0 0 1 772.003 77.6074)",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.67951,
    transform: "matrix(-1 0 0 1 771.545 77.4547)",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 771.239 77.1492)",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 771.239 77.1492)",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.54751,
    transform: "matrix(-1 0 0 1 787.73 78.0654)",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.54751,
    transform: "matrix(-1 0 0 1 771.24 78.3708)",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.606 76.2331C782.741 75.6733 780.492 74.6147 778.415 74.859C776.339 75.1033 775.514 75.8769 775.362 76.2331",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.844 95.4864C781.256 94.9978 779.637 95.69 779.027 96.0971C778.06 95.5882 775.759 94.8757 774.294 96.0971C772.461 97.624 771.545 101.441 768.95 102.51C766.873 103.365 763.911 102.866 762.69 102.51C768.644 106.632 772.003 104.953 774.294 104.953C776.584 104.953 776.278 101.441 777.347 101.441C778.202 101.441 778.823 101.848 779.027 102.052C779.739 101.695 781.5 101.288 782.844 102.51C784.523 104.037 791.547 104.8 795.669 104.953C798.967 105.075 800.809 102.357 801.318 100.983C800.402 102.052 798.265 101.441 795.669 101.441C793.074 101.441 784.829 96.0971 782.844 95.4864Z",
    fill: "#686666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.277 44.425C791.75 45.1884 791.903 47.4786 789.918 49.1581C789.177 49.9215 772.207 50.5323 766.71 54.96C761.214 59.3878 764.115 79.2365 763.046 78.4731C761.977 77.7097 763.198 62.1361 764.115 56.6396C765.031 51.143 770.069 45.9518 770.527 44.425C770.985 42.8982 782.589 40.1499 788.238 39.2338C792.758 38.5009 796.941 41.8803 798.468 43.6616C797.247 43.6616 794.498 43.8142 793.277 44.425Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.013 44.425C797.622 44.1426 793.277 44.425 793.277 49.1581C798.315 52.5171 798.315 54.6547 799.69 54.96C801.064 55.2654 803.303 55.0103 804.372 55.9264C805.441 56.8425 802.54 63.7132 804.372 64.6293C806.204 65.5454 804.474 66.0034 805.746 71.6527C806.088 73.1717 807.35 82.7135 808.189 80.8136C808.952 79.0839 814.602 73.3322 817.044 77.4546C817.334 77.9436 820.302 67.6327 818.011 66.1059C815.721 64.579 814.602 54.7049 813.227 53.0254C811.853 51.3459 810.784 45.2386 801.013 44.425Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.212 120.134C814.55 116.775 812.922 109.873 811.7 109.14C810.173 108.224 805.898 115.4 803.761 116.011C801.623 116.622 798.875 118.912 798.111 120.134C797.348 121.355 791.393 125.936 787.576 125.63C785.056 125.429 787.563 132.633 789.946 138.16C787.982 134.025 785.048 128.562 782.691 126.394C778.874 122.882 778.263 121.202 777.805 122.118C777.347 123.035 776.431 127.462 777.805 130.821C779.179 134.18 786.508 148.991 790.325 148.838C793.378 148.716 808.189 129.651 815.212 120.134Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.365 114.484C852.143 124.867 901.831 187.35 888.063 183.686L861.655 183.686L755.943 198.379C743.396 200.728 735.915 207.94 735.6 198.379C735.231 187.193 749.52 163.897 755.943 155.721C758.647 152.28 772.308 137.234 772.919 133.57C773.408 130.638 776.584 126.546 778.11 124.867C777.5 127.157 784.218 141.204 793.531 137.234C802.845 133.264 813.141 113.857 815.365 114.484Z",
    fill: "#1D1D1D"
  }))), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.5 213.204C1015.5 234.731 1010.41 254.049 1002.36 267.866C994.255 281.769 983.577 289.5 972.5 289.5C961.423 289.5 950.745 281.769 942.644 267.866C934.592 254.049 929.5 234.731 929.5 213.204C929.5 191.676 934.592 172.358 942.644 158.541C950.745 144.638 961.423 136.907 972.5 136.907C983.577 136.907 994.255 144.638 1002.36 158.541C1010.41 172.358 1015.5 191.676 1015.5 213.204Z",
    fill: "#ABABAB",
    stroke: "#4A4A4A",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3713_16728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 934,
    y: 140,
    width: 77,
    height: 144
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 972.5,
    cy: 212.056,
    rx: 38.463,
    ry: 71.7593,
    fill: "#D38337",
    fillOpacity: 0.3
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3713_16728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 913.37,
    y: 205.557,
    width: 117.111,
    height: 8.03704,
    transform: "rotate(-24.2173 913.37 205.557)",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.606,
    y: 221.186,
    width: 117.111,
    height: 2.86387,
    transform: "rotate(-24.2173 915.606 221.186)",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 203.701C985.494 203.339 984.933 203.038 984.322 202.813C981.671 201.835 978.814 202.54 976.908 204.388C976.238 203.654 975.388 203.066 974.393 202.699C972.106 201.855 969.65 202.4 967.937 203.907C967.417 203.425 966.795 203.035 966.09 202.775C964.063 202.027 961.881 202.546 960.401 203.932C960.482 203.543 960.592 203.157 960.731 202.777C962.781 197.161 970.438 194.822 977.832 197.551C981.384 198.861 984.229 201.103 986 203.701Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 203.701C985.494 203.339 984.933 203.038 984.322 202.813C981.671 201.835 978.814 202.54 976.908 204.388C976.238 203.654 975.388 203.066 974.393 202.699C972.106 201.855 969.65 202.4 967.937 203.907C967.417 203.425 966.795 203.035 966.09 202.775C964.063 202.027 961.881 202.546 960.401 203.932C960.482 203.543 960.592 203.157 960.731 202.777C962.781 197.161 970.438 194.822 977.832 197.551C981.384 198.861 984.229 201.103 986 203.701Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937 190.501C937.618 190.442 938.254 190.464 938.895 190.575C941.677 191.061 943.8 193.107 944.531 195.666C945.477 195.368 946.506 195.285 947.55 195.468C949.95 195.886 951.807 197.593 952.54 199.76C953.231 199.603 953.963 199.578 954.703 199.707C956.831 200.078 958.462 201.625 959.054 203.569C959.178 203.191 959.275 202.802 959.343 202.403C960.361 196.509 954.893 190.634 947.132 189.28C943.404 188.63 939.826 189.141 937 190.501Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.911 201.417C965.129 201.043 965.302 200.633 965.419 200.191C966.079 197.715 964.758 195.207 962.468 194.59C960.178 193.974 957.787 195.481 957.127 197.957C957.009 198.399 956.954 198.841 956.957 199.274L956.882 199.254L957.018 201.53C957.229 205.066 961.795 206.296 963.736 203.34L964.986 201.437L964.911 201.417Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.943 195.968C960.405 195.331 960.614 194.483 960.452 193.611C960.291 192.739 959.792 192.023 959.134 191.596C958.673 192.233 958.464 193.081 958.626 193.953C958.787 194.825 959.285 195.541 959.943 195.968Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.44 196.91C963.357 196.127 963.598 195.287 964.171 194.613C964.745 193.939 965.532 193.569 966.315 193.53C966.398 194.313 966.157 195.153 965.583 195.827C965.01 196.501 964.222 196.871 963.44 196.91Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.051,
    y: 259.075,
    width: 117.111,
    height: 17.952,
    transform: "rotate(-24.2173 919.051 259.075)",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.305 226.268C999.948 225.414 1000.76 223.438 1000.62 221.175C1001.56 221.941 1002.41 222.98 1003.05 224.233C1003.45 225.003 1003.73 225.791 1003.91 226.567L1008.04 242.791C1008.35 243.992 1006.83 244.779 1006.04 243.832L995.396 231.148C994.832 230.529 994.325 229.802 993.906 228.985C993.264 227.733 992.915 226.433 992.841 225.217C994.593 226.641 996.663 227.121 998.305 226.268Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.65 213.566C1021.65 213.566 1020.06 213.747 1019.33 214.128C1018.59 214.51 1014.81 215.238 1015.85 220.048C1014.86 220.048 1014.1 220.021 1013.16 220.51C1011 221.632 1009.75 222.643 1010.27 227.57C1008.97 226.151 1007.94 226.685 1007.28 227.031C1005.36 228.026 1004.54 230.651 1004.55 232.686C1004.32 232.362 1004.11 232.019 1003.93 231.659C1001.2 226.337 1004.65 219.08 1011.64 215.451C1014.99 213.708 1018.55 213.119 1021.65 213.566Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.526 238.048C974.526 238.048 975.593 236.849 976.327 236.467C977.061 236.086 979.845 233.401 983.131 237.048C983.704 236.235 984.127 235.592 985.067 235.104C987.226 233.982 988.77 233.541 992.455 236.825C992.06 234.937 993.087 234.403 993.754 234.057C995.669 233.062 998.273 233.904 999.91 235.097C999.782 234.721 999.625 234.351 999.44 233.991C996.713 228.668 988.838 227.296 981.852 230.925C978.497 232.668 975.957 235.248 974.526 238.048Z",
    fill: "#484848"
  }))), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.31 224.268C1007.95 223.414 1008.76 221.438 1008.62 219.175C1009.56 219.941 1010.41 220.98 1011.05 222.233C1011.45 223.003 1011.73 223.791 1011.91 224.567L1016.04 240.791C1016.35 241.992 1014.83 242.779 1014.04 241.832L1003.4 229.148C1002.83 228.529 1002.33 227.802 1001.91 226.985C1001.26 225.733 1000.92 224.433 1000.84 223.217C1002.59 224.641 1004.66 225.121 1006.31 224.268Z",
    fill: "#1B1B1B"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.65 211.566C1029.65 211.566 1028.06 211.747 1027.33 212.128C1026.59 212.51 1022.81 213.238 1023.85 218.048C1022.86 218.048 1022.1 218.021 1021.16 218.51C1019 219.632 1017.75 220.643 1018.27 225.57C1016.97 224.151 1015.94 224.685 1015.28 225.031C1013.36 226.026 1012.54 228.651 1012.55 230.686C1012.32 230.362 1012.11 230.019 1011.93 229.659C1009.2 224.337 1012.65 217.08 1019.64 213.451C1022.99 211.708 1026.55 211.119 1029.65 211.566Z",
    fill: "#1B1B1B"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M982.526 236.048C982.526 236.048 983.593 234.849 984.327 234.467C985.061 234.086 987.845 231.401 991.131 235.048C991.704 234.235 992.127 233.592 993.067 233.104C995.226 231.982 996.77 231.541 1000.46 234.825C1000.06 232.937 1001.09 232.403 1001.75 232.057C1003.67 231.062 1006.27 231.904 1007.91 233.097C1007.78 232.721 1007.63 232.351 1007.44 231.991C1004.71 226.668 996.838 225.296 989.852 228.925C986.497 230.668 983.957 233.248 982.526 236.048Z",
    fill: "#1B1B1B"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M1013 191.701C1012.49 191.339 1011.93 191.038 1011.32 190.813C1008.67 189.835 1005.81 190.54 1003.91 192.388C1003.24 191.654 1002.39 191.066 1001.39 190.699C999.106 189.855 996.65 190.4 994.937 191.907C994.417 191.425 993.795 191.035 993.09 190.775C991.063 190.027 988.881 190.546 987.401 191.932C987.482 191.543 987.592 191.157 987.731 190.777C989.781 185.161 997.438 182.822 1004.83 185.551C1008.38 186.861 1011.23 189.103 1013 191.701Z",
    fill: "#1B1B1B"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1013 191.701C1012.49 191.339 1011.93 191.038 1011.32 190.813C1008.67 189.835 1005.81 190.54 1003.91 192.388C1003.24 191.654 1002.39 191.066 1001.39 190.699C999.106 189.855 996.65 190.4 994.937 191.907C994.417 191.425 993.795 191.035 993.09 190.775C991.063 190.027 988.881 190.546 987.401 191.932C987.482 191.543 987.592 191.157 987.731 190.777C989.781 185.161 997.438 182.822 1004.83 185.551C1008.38 186.861 1011.23 189.103 1013 191.701Z",
    fill: "#1B1B1B"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M964 178.501C964.618 178.442 965.254 178.464 965.895 178.575C968.677 179.061 970.8 181.107 971.531 183.666C972.477 183.368 973.506 183.285 974.55 183.468C976.95 183.886 978.807 185.593 979.54 187.76C980.231 187.603 980.963 187.578 981.703 187.707C983.831 188.078 985.462 189.625 986.054 191.569C986.178 191.191 986.275 190.802 986.343 190.403C987.361 184.509 981.893 178.634 974.132 177.28C970.404 176.63 966.826 177.141 964 178.501Z",
    fill: "#1B1B1B"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M991.911 189.417C992.129 189.043 992.302 188.633 992.419 188.191C993.079 185.715 991.758 183.207 989.468 182.59C987.178 181.974 984.787 183.481 984.127 185.957C984.009 186.399 983.954 186.841 983.957 187.274L983.882 187.254L984.018 189.53C984.229 193.066 988.795 194.296 990.736 191.34L991.986 189.437L991.911 189.417Z",
    fill: "#1B1B1B"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M986.943 183.968C987.405 183.331 987.614 182.483 987.452 181.611C987.291 180.739 986.792 180.023 986.134 179.596C985.673 180.233 985.464 181.081 985.626 181.953C985.787 182.825 986.285 183.541 986.943 183.968Z",
    fill: "#1B1B1B"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M990.44 184.91C990.357 184.127 990.598 183.287 991.171 182.613C991.745 181.939 992.532 181.569 993.315 181.53C993.398 182.313 993.157 183.153 992.583 183.827C992.01 184.501 991.222 184.871 990.44 184.91Z",
    fill: "#1B1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3713_16728",
    x: 406.678,
    y: 66.2578,
    width: 16.9107,
    height: 14.2344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.50318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.751592
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3713_16728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3713_16728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3713_16728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Haunted-gray.6cd6a8b40bbf91a1abdcb9f172b8e5a2.svg";